import {createApp} from 'vue';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

//import {booleanPointInPolygon, point, buffer } from "@turf/turf";
//const turf = {booleanPointInPolygon, point, buffer };

gsap.registerPlugin(ScrollTrigger);


import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

// Turf
import * as turfHelpers from "@turf/helpers";
import turfLineChunk from "@turf/line-chunk";
import turfDistance from "@turf/distance"
import turfDestination from "@turf/destination"
import turfNearestPointOnLine from "@turf/nearest-point-on-line";
import turfLineSlice from "@turf/line-slice";
import turfBearing from "@turf/bearing";


import tipwalks from '../components/tipwalks/script.js';


const maps = document.querySelectorAll('.map-wrapper');
const breakpoint = 1127;

maps.forEach((map) => {

    if(!Array.isArray(window.map)){
        window.map = [];
    }
    window.map['map-' + map.dataset.unique] = null;
    let mapInstance = window.map['map-' + map.dataset.unique];


    let app = createApp({
        name: 'Karta - ' + map.dataset.unique,
        data() {
            return {
                unique: map.dataset.unique,
                rootEl: '#map-' + map.dataset.unique,
                settings: mapAppSettings,
                widgetSettings: window['mapAppSettingWidget_' + map.dataset.unique],
                isAndroid: false,
                isDev: false,
                noGeoLocation: false,
                mapbox: {
                    token: 'pk.eyJ1IjoibWlrYWVsYmV2ZW50b3JwIiwiYSI6ImNsZmNlemxvdjAxdWEzdGxyNTBnMGtta3kifQ.n6xahmSCAzoFwiq2lvurJA',
                    map: null,
                    lat: mapAppSettings.coordinates.lat,
                    lng: mapAppSettings.coordinates.lng,
                    bearing: mapAppSettings.coordinates.bearing,
                    pitch: 20,
                    pitchZoomed: 35,
                    zoom: 17,
                    bounds: null,
                    boundsOuter: null,
                    styles: [
                        'mapbox://styles/mapbox/standard',
                        //'mapbox://styles/mikaelbeventorp/clfcjrcth000m01qick96h1x8',
                    ],
                    activeFeature: null,
                    sources: [],
                    layers: [],
                },
                fullscreen: false,
                mapInactive: false,
                userMarker: null,
                showUserMarker: false,
                sidebar: {
                    state: 'open',
                    stateWorking: false,
                },
                scene: {
                    active: 'list',
                },
                use3d: false,
                isKiosk: false,
                markers: [],
                activeFloorIndex: null,
                activeFloorLayer: null,
                mapIsLoaded: false,
                mapIsLoading: false,
                useWatchPosition: true, // set to false if buggy positions
                mapIsAnimating: false,
                storeIsZoomed: false,
                activeStore: null,
                showExceptionHours: false,
                searchWord: '',
                storeIsHovered: false,
                services: {
                    source: mapAppSettings.serviceData,
                    active: [],
                    visible: [],
                    hidden: [],
                    ready: false,
                    moreOpen: false
                },
                terms: {
                    source: mapAppSettings.storeTerms,
                },
                currentPos: {},
                accuracy: 0,
                accuracyArr: [],
                acceptedAccuracy: 10,       // Meters. This will change dynamicly depending on geolocation accuracy
                acceptedAccuracyMin: 7,     // accuracy cant be smaller than this
                acceptedAccuracyMax: 20,    // accuracy cant exceed this
                //badAccuracy: 30,            // If accuracy is worse than this in meters, enable badAccuracyStreak
                //badAccuracyStreak: false,
                locationAgo: 0,             // Seconds since last geolacation callback
                locationInterval: null,
                locationThreshold: 5,  // How many soconds before we show user dots, fist couple of locations tend to be jumpy, adjust if not using watchPosition
                locationAgoIntervall: null,
                userDotAnimationIntervall: null,
                trackingInterval: 5000, // milliseconds between geolocation pings
                locationOptions: {
                    enableHighAccuracy: true,
                    timeout: 10000, // 10 sec on first check
                    maximumAge: 0
                },
                locationUpdateOptions: {
                    enableHighAccuracy: true,
                    timeout: 6000,
                    maximumAge: 2000
                },
                compassActive: false,
                compassPitch: 0,
                compass: null,
                offers: {
                    show: false,
                },
                distanceArr: { // Distance per pixel on different zoom levels, used for accuracy radius (https://docs.mapbox.com/help/glossary/zoom-level/)
                    10: [76.437, 71.827, 58.554, 38.218, 13.273],
                    11: [38.218, 35.914, 29.277, 19.109, 6.637],
                    12: [19.109, 17.957, 14.639, 9.555, 3.318],
                    13: [9.555, 8.978, 7.319, 4.777, 1.659],
                    14: [4.777, 4.489, 3.660, 2.389, 0.830],
                    15: [2.389, 2.245, 1.830, 1.194, 0.415],
                    16: [1.194, 1.122, 0.915, 0.597, 0.207],
                    17: [0.597, 0.561, 0.457, 0.299, 0.104],
                    18: [0.299, 0.281, 0.229, 0.149, 0.052],
                    19: [0.149, 0.140, 0.114, 0.075, 0.026],
                    20: [0.075, 0.070, 0.057, 0.037, 0.013],
                    21: [0.037, 0.035, 0.029, 0.019, 0.006],
                    22: [0.019, 0.018, 0.014, 0.009, 0.003],
                },
                overlayMessage: {
                    active: false,
                    msg: ''
                },
                mapReady: false,
                autoZoomPosition: true,
                compass3d: false,
                showDevSettings: false,
                compassShowNotice: false,
                showLoader: true,
                kioskBearing: false,
                showRoute: false,
                markerRoute: null,
                showGeoLocationDebug: false,

                // Geo pos ranking
                useRankPosition: true,
                badAccuracyConsideration: 21,
                acceptedJumpDistance: 30,  // If user position jumps more than this, ignore
                maxTimeWithBadGPS: 10000,      // Wait this long before activate GPS AGAIN AFTER BAD GPS
                lastGoodPosition: null,
                lastBadPosition: null,
                lastBadSignalTime: null,
                lastPosTimestamp: null,
                acceptedJumpPerSecond: 6, // If user jumps more than this per second, ignore
                posRankArr: [],
                badAccuracyDemoMode: false,
                badSignalText: 'Just nu är det lite dålig signal.',
                badRankText: '',
                userIsInBounds: true,
                userBoundsNotified: false,
            }
        },
        mixins: [
            tipwalks
        ],
        computed: {
            isDev() {
                return window.location.hostname.includes(".test");
            },
            isDemo() {
                return this.widgetSettings.demo;
            },
            useGeolocation() {
                //return false;
                return (this.isDemo || this.mobile) && !this.isTipwalk;
            },
            useCompass() {
                return this.mobile && this.accuracy;
            },
            showFloors() {
                return this.settings.floorData.length > 1 && !this.isTipwalk;
            },
            showSidebarTop() {
                return !this.activeStore || this.isKiosk;
            },
            mobile() {
                return /Android|iPhone/i.test(navigator.userAgent) || this.smallScreen;
            },
            smallScreen() {
                return window.innerWidth < breakpoint;
            },
            map() {
                return mapInstance;
            },
            compassAngle() {
                if (!mapInstance) return 0;
                return mapInstance.getBearing();
            },
            isBadAccuracy() {
                // Check last 5 ranks from position array and see if they are all bad
                if(this.posRankArr.length < 5) return false;
                let arr = this.posRankArr.slice(-5);
                // Check if all last 5 are bad
                let count = 0;
                arr.forEach(function (item) {
                    if (item === 0) {
                        count++;
                    }
                });

                let bad = count >= 5;
                // Do not follow marker if bad accuracy
                this.autoZoomPosition = !bad;

                return bad;
            },
            mapPitch() {
                if (this.use3d) return 30;
                return 0;
            },
            mapPitchFocused() {
                if (this.use3d) return 35;
                return 0;
            },
            mapPadding() {
                let padding = 5;
                if (window.innerWidth > breakpoint) {
                    padding = 100;
                }
                if (this.isTipwalk) {
                    padding = 50;
                }
                return padding;
            },
            mapMaxZoom() {
                let maxZoom = 18;
                if (window.innerWidth > breakpoint) {
                    maxZoom = 18;
                }
                if (this.isTipwalk) {
                    maxZoom = 18;
                }
                return maxZoom;
            },
            mapMinZoom() {
                let minZoom = 13;
                if (window.innerWidth > breakpoint) {
                    minZoom = 14;
                }
                return minZoom;
            },
            leftPadding() {
                let leftPadding = this.mapPadding;
                if (window.innerWidth > breakpoint) {
                    leftPadding = 385 + this.mapPadding;
                }

                if (this.widgetSettings.only_map) {
                    leftPadding = 0;
                }

                return leftPadding;
            },
            stores() {
                let app = this;
                return this.settings.storeData.filter(function (item) {
                    if (!app.searchWord.length) return true;

                    if (app.searchWord.length) {
                        if (item.title.toLowerCase().includes(app.searchWord.toLowerCase())) {
                            return true;
                        }
                    }
                });
            },
            activeFloorLabel() {
                if (this.activeFloorIndex !== null) {
                    return this.settings.floorData[this.activeFloorIndex].info.label;
                }
                return 'Våning..';

            },
            activeFeature() {
                return this.mapbox.activeFeature;
            },
            activeStoreOffers() {
                let app = this;
                if (!this.activeStore) return [];
                if (!this.settings.offers.length) return [];
                return this.settings.offers.filter(function (offer) {
                    return offer.stores && offer.stores.includes(app.activeStore.postId);
                });
            }
        },
        watch: {
            activeStore: {
                handler(newVal, oldVal) {
                    if (newVal) {
                        this.zoomToStore();
                    } else {
                        this.resetMap();
                    }
                },
            },
            isBadAccuracy: {
                handler(newVal, oldVal) {
                    let app = this;

                    if (newVal) {
                        gsap.to(app.rootEl + ' .bad-geo', {y: -200, duration: 1, ease: 'elastic.out(1, 0.4)'});
                    } else {
                        gsap.to(app.rootEl + ' .bad-geo', {y: 0, duration: 0.3, ease: 'power1'});

                    }

                }
            },
            userIsInBounds: {
                handler(newVal, oldVal) {
                    let app = this;

                    if (!newVal && !app.userBoundsNotified) {

                        app.overlayMessage.active = true;
                        app.overlayMessage.msg = app.widgetSettings.outside_bound_text;
                        app.userBoundsNotified = true;
                    }
                }
            },
            activeFeature: {
                handler(newVal, oldVal) {
                    if (
                        (newVal && oldVal && newVal.id !== oldVal.id) ||
                        (!newVal && oldVal)
                    ) {
                        this.resetFeature(oldVal);
                    }
                },
            }
        },
        methods: {
            log(str) {
                if (this.isDemo) {
                    document.getElementById("dev-log-txt").value += str + '\n';
                }
                if(this.isDev){
                    console.log(str);
                }

            },
            getMobileOS() {
                const ua = navigator.userAgent
                if (/android/i.test(ua)) {
                    return "Android"
                } else if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
                    return "iOS"
                }
                return "Other"
            },
            /*
            checkBadAccuracy() {
                // Check if last accuracy is bad. If bad, skip updating.
                // If last 5 accuracy values are bad show a notice
                let app = this;

                let lastPing = this.accuracyArr[this.accuracyArr.length - 1];
                if (lastPing > this.acceptedAccuracyMax) {

                    // Check if all last 5 are bad
                    let lastAccuracys = this.accuracyArr.slice(-5);
                    let badStreak = true;
                    let count = 0;

                    lastAccuracys.forEach(function (item) {
                        if (item <= app.badAccuracy) {
                            count++;
                            badStreak = false;
                        }
                    });

                    this.badAccuracyStreak = badStreak;
                    this.log('Bad streak: ' + this.badAccuracyStreak);

                    return true;
                }
                return false;
            },

             */
            updateServiceBtns() {
                let app = this;

                let serviceList = document.querySelector(app.rootEl + ' .services .list');
                let serviceBtns = document.querySelector(app.rootEl + ' .services button.offers');

                let availableWidth = serviceList ? serviceList.offsetWidth - 200 : 0; // Extra for "Visa mer" to have proper room
                let btnsWidth = serviceBtns ? serviceBtns.offsetWidth : 0;

                // Reset stuff
                app.services.visible = [];
                app.services.hidden = [];

                this.services.source.forEach(function (btn, i) {
                    app.services.visible.push(btn);

                    // Do width check only for desktop
                    if (window.innerWidth < breakpoint) {
                        return;
                    }

                    app.$nextTick(function () {
                        let el = document.querySelector(app.rootEl + ' .services button.' + btn.slug);
                        if (!el) return;
                        btnsWidth += el.offsetWidth;
                        // If width limit is reached, move btn to hidden list
                        if (btnsWidth > availableWidth) {
                            app.services.visible = app.services.visible.filter(function (item) {
                                return item.slug !== btn.slug;
                            });

                            app.services.hidden.push(btn);
                        }
                    })
                });

                window.removeEventListener('resize', this.updateServiceBtns);
                window.addEventListener('resize', this.updateServiceBtns);

                this.services.ready = true;
            },
            setScene(scene, reset = false) {

                this.scene.active = scene;

                this.searchWord = '';
                let app = this;

                let left = '2px';
                if (scene === 'categories') left = 'calc(50% - 2px)';
                gsap.to(app.rootEl + ' .tabs-plate', {left: left, duration: 0.75, ease: 'elastic.out(1, 0.75)'});

                this.$nextTick(function () {
                    // Focus search on desktop
                    if (['list', 'categories'].includes(scene) && !this.mobile) {
                        app.$refs.searchInput.focus();
                    }
                    // Scroll to top (For mobile mainly)
                    jQuery(".map-wrapper").animate({scrollTop: 0}, 400);
                })

                // Always start sidebar on top
                jQuery(".sidebar").scrollTop(0);


                // Update sidebar state for mobile
                if (reset) {
                    this.sidebar.state = 'hidden';
                } else if (['list', 'categories'].includes(scene)) {
                    this.sidebar.state = 'open';
                } else {
                    this.sidebar.state = 'semiOpen';
                }

                // Reset stuff when changing scene
                this.clearServices();

            },

            checkParams() {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);

                // Check for some stuff
                if (urlParams.has('watch')) {
                    this.useWatchPosition = true;
                }
                if (urlParams.has('nowatch')) {
                    this.useWatchPosition = false;
                }
                if (urlParams.has('nogeo')) {
                    this.noGeoLocation = true;
                }
                if (urlParams.has('trigger') && urlParams.get('trigger') === 'tipwalk' && this.isTipwalk && this.mobile) {
                    this.openLightbox();
                }
            },
            toggleAutoZoom() {
                this.autoZoomPosition = !this.autoZoomPosition;
            },
            toggleCompass3d() {
                this.compass3d = !this.compass3d;
            },
            toggle3d(justToggle = false) {
                let app = this;
                this.use3d = !this.use3d;
                // Update source layer for extrusion height update
                mapInstance
                    .getSource(app.getActiveStoreLayer())
                    .setData(app.getStoresGeoData(app.activeFloorIndex));

                // If just toggling, return here, map flight will take place else where
                if(justToggle) return;

                let center = mapInstance.getCenter();
                let bearing = this.use3d ? Math.round(this.mapbox.bearing) + 5 : this.mapbox.bearing; // tweek the map a bit to emphasise 3d viw

                mapInstance.flyTo({
                    center: center,
                    pitch: app.mapPitch,
                    bearing: bearing,
                    duration: 2000,
                    essential: true
                });
            },
            setFloor(floorNum, reset = false) {
                let app = this;

                if (!floorNum && floorNum !== 0) {
                    // Set default
                    this.settings.floorData.forEach(function (floor, i) {
                        if (floor.info.default) {
                            floorNum = i;
                        }
                    });
                }

                this.activeFloorIndex = floorNum;

                // remove active state
                this.settings.floorData.forEach(function (floor, i) {
                    floor.active = false;
                });

                this.activeFloorLayer = this.mapbox.layers[floorNum];

                // Add active state
                this.settings.floorData[floorNum].active = true;

                // Toggle which layer is visible
                this.mapbox.layers.forEach(function (layer) {
                    mapInstance.setLayoutProperty(layer, 'visibility', 'none');
                });

                // Handle markers
                this.updateFloorMarkers();

                this.resetMap();

                // Search for all layers in this floor and show them
                this.mapbox.layers.forEach(function (layer) {
                    if (['layer-floor-' + floorNum, 'layer-floor-extra-' + floorNum].includes(layer)) {
                        mapInstance.setLayoutProperty(layer, 'visibility', 'visible');
                    }
                });

                // reset sidebar if no store is active
                if(reset) {
                    //this.activeStore = null;
                    this.setScene('list', true);
                }

            },
            zoomIn() {
                let zoom = mapInstance.getZoom();
                let center = mapInstance.getCenter();
                mapInstance.flyTo({center: center, zoom: zoom + 1});
            },
            zoomOut() {
                let zoom = mapInstance.getZoom();
                let center = mapInstance.getCenter();
                mapInstance.flyTo({center: center, zoom: zoom - 1});
            },
            toggleMoreServices() {
                this.log('Services!');
            },
            updateFloorMarkers() {
                this.log('update markers, floor: ' + this.activeFloorIndex);
            },
            getStoresGeoData(index, reset = false) {
                let app = this;

                let data = JSON.parse(this.settings.floorData[index].geojson);

                if(data){
                    data.features.forEach(function (feat, i) {
                        if (!app.use3d) {
                            feat.properties.height = 0;
                        } else if (!reset && app.mapbox.activeFeature && feat.id === parseInt(app.mapbox.activeFeature.id)) {
                            feat.properties.height = 6;
                        } else {
                            feat.properties.height = 3;
                        }
                    });

                    return data;
                }

                return [];

            },
            clearSearch() {
                let app = this;
                this.searchWord = '';
                this.$nextTick(() => app.$refs.searchInput.focus());
            },
            openStore(store) {

                // Disable false click on mobile after sidebar state change
                if(this.sidebar.stateWorking){
                    return;
                }

                this.activeStore = store;
                if(this.isKiosk) return;
                this.setScene('store');
            },
            openOther(obj) {
                // Zoom into place
                let app = this;

                this.log('Other area: ' + obj.otherLabel);

                // Reset and add new bounds (https://docs.mapbox.com/mapbox-gl-js/example/zoomto-linestring/)
                let tempBounds = [[obj.coordinates.lng, obj.coordinates.lat]];

                this.mapbox.bounds = tempBounds.reduce(function (bounds, coord) {
                    return bounds.extend(coord);
                }, new mapboxgl.LngLatBounds(tempBounds[0], tempBounds[0]));


                // Make sure not to zoom to much
                mapInstance.fitBounds(app.mapbox.bounds, {
                    maxZoom: app.mapMaxZoom,
                    pitch: this.mapPitchFocused,
                    bearing: this.mapbox.bearing,
                    //speed: 0.75,
                    duration: 2000,
                    essential: true,
                    padding: {
                        top: app.mapPadding,
                        bottom: app.mapPadding,
                        left: app.leftPadding,
                        right: app.mapPadding
                    }
                });

            },
            toggleOffers() {
                this.offers.show = !this.offers.show;
            },
            toggleStoreOffers(storeId = false, reset = false) {
                let app = this;

                if(!storeId) {
                    // Set to active store if any
                    if(app.activeStore && app.activeStore.hasOwnProperty('postId')){
                        storeId = app.activeStore.postId;
                    }
                }

                // Check if there are any offers for this store
                jQuery(app.rootEl + ' .marker-offer').removeClass('active-hide');
                if(!reset || !storeId) {
                    jQuery(app.rootEl + ' .marker-offer.store-offer-' + storeId ).addClass('active-hide');
                }
                // Always make sure to hide on active store, even when hovering other
                if(app.activeStore && app.activeStore.hasOwnProperty('postId')) {
                    jQuery(app.rootEl + ' .marker-offer.store-offer-' + app.activeStore.postId ).addClass('active-hide');
                }
            },
            openLightbox() {
                let app = this;

                let el = document.querySelector(this.rootEl + '.lightbox');
                let inner = el.querySelector('.inner-main');
                if (el) el.classList.add('open');

                // Add class to html tag to handle scroll
                document.documentElement.classList.add('lightbox-map');

                let animationTime = 0.4;

                gsap.fromTo(inner, {opacity: 1, yPercent: 0, scaleX: 0.8}, {
                    yPercent: -20,
                    scaleX: 1,
                    opacity: 1,
                    duration: animationTime,
                    ease: 'Expo.easeOut'
                });

                // Initialite here since now is when we need tha map
                if (!this.mapIsLoaded) {
                    setTimeout(function () {

                        app.initMap();
                    }, animationTime * 1000)
                }
            },
            closeLightbox() {
                let app = this;
                let el = document.querySelector(this.rootEl + '.lightbox');
                let inner = el.querySelector('.inner-main');
                if (el) el.classList.remove('open');

                document.documentElement.classList.remove('lightbox-map');

                gsap.to(inner, {yPercent: 0, opacity: 0, duration: 0, ease: 'power4.out'});

                this.resetApp();

            },
            resetApp() {
                this.resetSidebar();
                this.setScene('list', true);
                this.stopLocationWatch();
                if (this.use3d) this.toggle3d();
                this.resetMap();
            },
            dragSidebar() {
                this.log('SIDEBAR DRAGGED!');
            },
            toggleStoreDragControl() {
                let app = this;

                if (this.sidebar.stateWorking) return;

                if (this.sidebar.state === 'semiOpen') {
                    this.sidebar.state = 'open';
                } else if (this.sidebar.state === 'open') {
                    this.sidebar.state = 'semiOpen';
                }

                this.sidebar.stateWorking = true;
                setTimeout(() => {
                    app.sidebar.stateWorking = false;
                }, 500);

            },
            openMessage() {
                this.overlayMessage.active = true;
            },
            closeMessage() {
                this.overlayMessage.active = false;
            },
            getOuterBounds() {

                // Using Turf.js, create a radius around the center where the map can operate
                let bounds = new mapboxgl.LngLatBounds();


                /*
                let point = turf.point([this.mapbox.lng, this.mapbox.lat]);

                // make sure the coordinates is integers, not sure why not happening as default.
                point.geometry.coordinates[0] = parseFloat(point.geometry.coordinates[0]);
                point.geometry.coordinates[1] = parseFloat(point.geometry.coordinates[1]);

                let buffer = turf.buffer(point, 400, {units: 'meters'});


                buffer.geometry.coordinates.forEach(function (coors) {
                    bounds.extend([coors[0], coors[1]]);
                });

                return buffer;

                 */


            },
            closeStore() {
                let app = this;
                this.setScene('list', true);

                if (app.activeStore) {
                    // Animate away marker
                    gsap.set(app.rootEl + ' .marker-store.store-' + app.activeStore.postId + ' .inner', {
                        yPercent: 0,
                        opacity: 0
                    });

                    this.activeStore = null;
                }

            },
            toggleTerm(termId){
                this.terms.source.forEach(function (term) {
                    if(term.term_id === termId){
                        term.active = !term.active;
                    }
                });
            },
            toggleService(service) {
                let app = this;

                this.services.active = this.toggleArrElement(this.services.active, service.slug);

                this.services.source.forEach(function (item) {
                    let scale = 0;
                    let duration = 0.4;
                    let ease = 'expo.out';
                    let delay = 0;
                    // If showing, add some sugar
                    if (app.services.active.includes(item.slug) ) {
                        scale = 1;
                        ease = 'elastic.out(1, 0.4)';
                        duration = 1.0;
                    }
                    let markers = document.querySelectorAll(app.rootEl + ' .marker-service.floor-' + app.activeFloorIndex + '.' + item.slug + ' .inner');
                    if (markers) {
                        markers.forEach(function (el) {
                            gsap.to(el, {scale: scale, duration: duration, ease: ease, delay: delay});
                            delay += 0.1;
                        })
                    }
                });

                app.services.animating = true;

                app.zoomBounds();

                setTimeout(() => app.services.animating = false, 1000);

                app.$nextTick(function () {
                    // Scroll to top (For mobile mainly)
                    jQuery(".map-wrapper").animate({scrollTop: 0}, 400);
                });

                // Show map when new choice is done on mobile
                if (this.smallScreen) {
                    this.sidebar.state = 'hidden';
                }


            },
            clearServices() {
                let app = this;

                //Hide any visible
                this.services.source.forEach(function (service) {
                    let scale = 0;
                    let duration = 0;
                    let ease = 'expo.out';
                    let delay = 0;
                    let markers = document.querySelectorAll(app.rootEl + ' .marker-service.' + service.slug + ' .inner');
                    if (markers) {
                        markers.forEach(function (el) {
                            gsap.to(el, {scale: scale, duration: duration, ease: ease, delay: delay});
                            delay = 0;
                        })
                    }
                });

                // Clear array
                this.services.active = [];
                app.zoomBounds();
            },

            // Helper - array value toggle
            toggleArrElement(arr, val) {
                return arr.includes(val) ? arr.filter(el => el !== val) : [...arr, val];
            },
            getTermStores(termId) {
                let arr = this.stores.filter((item) => item.tax.includes(termId));
                if (!arr.length) return false;
                return arr;
            },
            requestUserLocation() {
                let app = this;

                this.mapIsLoading = true;

                if (this.isDev || this.noGeoLocation) {

                    this.log('DEMO LOCATION REQUEST');

                    let randLat = (Math.random() < 0.5 ? Math.random() * -1 : Math.random()) / 1000;
                    let randLng = (Math.random() < 0.5 ? Math.random() * -1 : Math.random()) / 1000;
                    let pos = {
                        coords: {
                            longitude: parseFloat(app.settings.coordinates.lng) + randLng,
                            latitude: parseFloat(app.settings.coordinates.lat) + randLat,
                        }
                    }

                    this.currentPos = Object.assign({}, pos);
                    this.showUserMarker = true;

                    if (!this.userMarker) {
                        this.addUserLocation();
                    } else {
                        this.log('DEMO LOCATION UPDATE');
                        this.locationUpdate(this.currentPos);
                        this.zoomBounds();
                    }

                    this.mapIsLoading = false;


                } else {

                    this.getPosition().then(app.locationSuccess).catch(app.locationError);
                    //navigator.geolocation.getCurrentPosition(app.locationSuccess, app.locationError, app.locationOptions);

                    // Create outer bounds
                    //this.mapbox.boundsOuter = this.getOuterBounds();

                }
            },
            getPosition(){
                let app = this;
                return new Promise((resolve, reject) =>
                    navigator.geolocation.getCurrentPosition(resolve, reject, app.locationOptions)
                );
            },
            locationSuccess(pos) {
                let app = this;

                //app.currentPos.coords.longitude = pos.coords.longitude;
                // app.currentPos.coords.latitude = pos.coords.latitude;

                this.currentPos = pos;

                this.log('locationSuccess');

                this.checkUserPosition();


                // If position was out of bounds, exit here
                if (!this.showUserMarker) {
                    this.mapIsLoading = false;
                    alert('Out of bounds');
                    return;
                }



                // On tipwalks, chill with user position since it's jumpy in the beginning
                let chillTimer = 0;
                if (this.isTipwalk) chillTimer = 4000;

                setTimeout(() => {
                    app.addUserLocation();
                }, chillTimer);


                // Trigger compass notice after a while
                if (this.isTipwalk) {
                    setTimeout(() => {
                        app.compassNotice();
                    }, 15000); // 15 sec in
                }


                if (this.showUserMarker) {
                    // Setup interval to check user position
                    if (this.useWatchPosition) {
                        // If using watchPosition method
                        this.locationWatchId = navigator.geolocation.watchPosition(app.locationUpdate, app.locationUpdateError, app.locationUpdateOptions);
                    } else {
                        this.locationInterval = setInterval(function () {
                            navigator.geolocation.getCurrentPosition(app.locationUpdate, app.locationUpdateError, app.locationUpdateOptions);
                        }, app.trackingInterval);
                    }
                }

                this.mapIsLoading = false;

                // Zoom into new location on first success
                this.zoomBounds();

            },
            stopLocationWatch() {
                let app = this;

                if (this.useWatchPosition) {
                    navigator.geolocation.clearWatch(app.locationWatchId);
                    //console.log('Stop location watch');
                } else {
                    clearInterval(app.locationInterval);
                }
                clearInterval(app.locationAgoIntervall);

            },
            toggleGeoWatch() {
                let app = this;
                // Stop watch and switch function
                this.stopLocationWatch();

                this.useWatchPosition = !this.useWatchPosition;

                // Set it up again
                if (this.useWatchPosition) {
                    this.locationWatchId = navigator.geolocation.watchPosition(app.locationUpdate, app.locationUpdateError, app.locationUpdateOptions);
                } else {
                    this.locationInterval = setInterval(function () {
                        navigator.geolocation.getCurrentPosition(app.locationUpdate, app.locationUpdateError, app.locationUpdateOptions);
                    }, app.trackingInterval);
                }

            },
            locationError(err) {
                // dont do anything on these errors..
                this.mapIsLoading = false;

                let title = 'Kunde inte hitta din position';
                let description = 'Försök igen eller kontrollera att du har aktiverat platstjänster.';

                if(err.PERMISSION_DENIED){
                    title = 'Platstjänster inaktiva';
                    description = 'För att använda din position behöver du aktivera platstjänster.';
                }
                else if(err.POSITION_UNAVAILABLE){
                    title = 'Din plats är ej tillgänglig';
                    description = 'Din platstjänst är inte tillgänglig just nu. Försök igen senare.';
                }

                description += ' <br><a href="' + mapAppSettings.geolocationPage + '" style="text-decoration: underline;">Läs om hur du löser det &rarr;</a>';

                this.overlayMessage.active = true;
                this.overlayMessage.msg = '<b>' + title + '</b><br>' + description;

            },
            locationUpdate(pos) {
                let app = this;

                // Put data in a new object that is not read only so we can modify values if needed
                let geoObject = {
                    coords: {
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude,
                        accuracy: pos.coords.accuracy,
                        altitude: pos.coords.altitude,
                        altitudeAccuracy: pos.coords.altitudeAccuracy,
                        heading: pos.coords.heading,
                        speed: pos.coords.speed
                    },
                    timestamp: pos.timestamp
                };

                if(this.badAccuracyDemoMode) {

                    // Use turf to get a point 10 meters away
                    let point = turfHelpers.point([pos.coords.longitude, pos.coords.latitude]);
                    let bearing = Math.floor(Math.random() * 360);
                    // Set distance to a random value between 10 and 30 meters
                    let distance = Math.floor(Math.random() * 20) + 20;
                    let units = 'meters';
                    let destination = turfDestination(point, distance, bearing, {units: units});

                    let coordinates = destination.geometry.coordinates;
                    geoObject.coords.latitude = coordinates[1];
                    geoObject.coords.longitude = coordinates[0];

                    geoObject.coords.accuracy = distance;

                }


                if(this.useRankPosition){
                    // Run position through filter first to see if it's good enough to use
                    let rank = this.rankPosition(geoObject);

                    this.log('Rank:', rank);

                    this.posRankArr.push(rank);

                    //console.log('Rank arr:', this.posRankArr);
                    if (rank === 2) {
                        // Not good due to bad accuracy, fix it with filtered position
                        const filteredPos = this.getFilteredPosition(pos.coords.latitude, pos.coords.longitude);

                        geoObject.coords.latitude = filteredPos.latitude;
                        geoObject.coords.longitude = filteredPos.longitude;

                        //console.log("Filtrerad position:", filteredPos.latitude, filteredPos.longitude);
                    } else if (rank === 0) {
                        // Not good due to bad accuracy, skip this position
                        return;
                    }
                }



                let crd = geoObject.coords;

                this.accuracy = crd.accuracy;

                this.currentPos = geoObject;

                // Update accuracy median
                this.acceptedAccuracy = this.updateAccuracy(crd);

                if (this.isDev) {
                    this.acceptedAccuracy = 50;
                }


                // Update accuracy median
                app.updateUserPoint(crd.longitude, crd.latitude);

                // Check if any offer markers are close enough to current pos
                app.checkNearbyOffers(crd);

                // Check nearby tipwalk marker
                app.checkNearbyTipwalk(crd);


                // Follow user?
                if (this.autoZoomPosition) {
                    this.log('Following user!');
                    app.zoomBounds();
                }

            },
            rankPosition(newPos) {

                // 0 = bad - skip
                // 1 = good - all good
                // 2 = semi - bad accuracy, filter pos

                // Funktion för att avgöra om en position är pålitlig

                if (!newPos || !newPos.coords) return 0;

                const { latitude, longitude, accuracy } = newPos.coords;
                const timestamp = newPos.timestamp;


                let rank = 1;
                let rankText = '';

                // 1. Ignorera positioner med för hög felmarginal
                if (accuracy > this.badAccuracyConsideration) {
                    rankText = "Svag GPS-signal: Ignorerar position (accuracy =" + accuracy + "m)";
                    rank = 2;
                }

                // 2. Om signalen förbättras, återaktivera GPS
                this.lastBadSignalTime = null;

                let timeSinceLastPos = (timestamp - this.lastPosTimestamp)/1000;

                // 3. Kolla om positionen hoppar orimligt långt från förra "bra" positionen
                if (this.lastGoodPosition) {
                    const from = turfHelpers.point([this.lastGoodPosition.coords.longitude, this.lastGoodPosition.coords.latitude]);
                    const to = turfHelpers.point([longitude, latitude]);
                    const distance = turfDistance(from, to, { units: "meters" });

                    // Reasonable max jump is 6m per 1s (Running speed is 5-6m/s)
                    //console.log("Distance: " + distance + "m, Time since last pos: " + timeSinceLastPos)
                    if((distance / timeSinceLastPos) > this.acceptedJumpPerSecond) {
                        rankText = "Orimligt hopp för tid: " +  distance + "m";
                        rank = 0;
                    }


                    if (distance > this.acceptedJumpDistance) {
                        rankText = "Position ignorerad: Orimligt hopp: " +  distance + "m";
                        rank = 0;
                    }
                }

                // 4. Kolla om positionen är väldigt nära förra "dåliga" positionen
                // Det kan isof vara en hyffsat bra position som filtreras bort pga dåligt hopp innan
                if(this.lastBadPosition && rank === 0) {
                    const from = turfHelpers.point([this.lastBadPosition.coords.longitude, this.lastBadPosition.coords.latitude]);
                    const to = turfHelpers.point([longitude, latitude]);
                    const distance = turfDistance(from, to, { units: "meters" });

                    if (distance < this.acceptedJumpDistance) {
                        rankText = "Position tillräckligt bra från förra dåliga, " +  distance + "m";
                        rank = 2; // Give it a rank of 2 so we are back in business with user marker
                    }

                    // Just make sure that jump is not to big from last good position
                    // Reasonable max jump is 6m per 1s (Running speed is 5-6m/s)
                    if((distance / timeSinceLastPos) > this.acceptedJumpPerSecond) {
                        rankText = "Orimligt hopp för tid: " +  distance + "m";
                        rank = 0;
                    }
                }

                this.log("Rank: " + rank + " - " + rankText);
                this.badRankText = rankText;


                // 4. Spara senaste godkända positionen
                if(rank !== 0) {
                    this.lastGoodPosition = newPos;
                } else {
                    this.lastBadPosition = newPos;
                }

                // 5. Spara senaste tidpunkt för position
                this.lastPosTimestamp = timestamp;

                /*
                if(this.badAccuracyDemoMode) {
                    return 0;
                }

                 */


                return rank;
            },
            getFilteredPosition(lat, lng) {
                // Få avrundad position från Kalman-funktion
                return {
                    latitude: kalmanLat.filter(lat),
                    longitude: kalmanLng.filter(lng)
                };
            },

            compassNotice() {
                let app = this;
                this.compassShowNotice = true;

                app.$nextTick(() => gsap.to(app.rootEl + ' .compass-notice .animate', {
                    yPercent: -100,
                    opacity: 1,
                    duration: 1.2,
                    ease: 'elastic.out(1, 0.3)'
                }));

                // If nothing is clicked, hide again after 1min
                setTimeout(() => {
                    gsap.to(app.rootEl + ' .compass-notice .animate', {
                        yPercent: 0,
                        opacity: 0,
                        duration: 0.3,
                        ease: 'power4.out'
                    })
                }, 60000);

                setTimeout(() => {
                    app.compassShowNotice = false;
                }, 61200);

            },
            checkNearbyOffers(crd) {

                // Skip this on tipwalks
                if (this.isTipwalk) return;

                let meters, distance;
                let app = this;

                this.settings.offers.forEach(function (offer) {

                    // Only add if we have coordinates
                    if (!offer.coordinates) return;

                    offer.coordinates.forEach(function (store) {
                        distance = app.getDistance("userPos", crd.latitude, crd.longitude, "checkpoint", store.lat, store.lng);

                        meters = parseFloat(distance.distance_kilometres) * 1000;

                        if (meters <= app.acceptedAccuracy) {
                            app.showOfferMarker(offer);
                        } else {
                            app.hideOfferMarker(offer);
                        }
                    });

                });
            },
            checkUserPosition() {
                let app = this;

                this.showUserMarker = true;
                return;

                // Make sure the user is within the bounds of the centre
                if (app.currentPos.coords.longitude > app.mapbox.boundsOuter._ne.lng && app.currentPos.coords.longitude < app.mapbox.boundsOuter._sw.lng && app.currentPos.coords.latitude > app.mapbox.boundsOuter._ne.lat && app.currentPos.coords.latitude < app.mapbox.boundsOuter._sw.lat) {
                    this.showUserMarker = true;
                } else {
                    this.overlayMessage.active = true;
                    this.overlayMessage.msg = 'Din position verkar vara utanför området. Försök igen när du är på plats!';
                    this.showUserMarker = false;
                }


                /*
                // Turf solution.. Make surte the user is within the bounds of the centre
                if (!turf.booleanPointInPolygon([app.currentPos.coords.longitude, app.currentPos.coords.latitude], app.mapbox.boundsOuter)) {
                    this.overlayMessage.active = true;
                    this.overlayMessage.msg = 'Din position verkar vara utanför området. Försök igen när du är på plats!';
                    this.showUserMarker = false;
                } else {
                    this.showUserMarker = true;
                }

                 */
            },
            ifOutOfBounds(){
                let app = this;

                let pos = mapInstance.getCenter();

                if (pos.lng > app.mapbox.boundsOuter._ne.lng || pos.lng < app.mapbox.boundsOuter._sw.lng || pos.lat > app.mapbox.boundsOuter._ne.lat || pos.lat < app.mapbox.boundsOuter._sw.lat) {
                    this.log('OUT OF BOUNDS');

                    // Go back to center
                    app.centerMap();

                } else {
                    this.log('IN BOUNDS');
                }
            },
            toggleCompass() {
                if (this.compassActive) {
                    this.stopCompass();
                } else {
                    this.startCompass();
                }

            },
            stopCompass() {
                let app = this;

                window.removeEventListener("deviceorientation", app.compassHandler, true);
                window.removeEventListener("deviceorientationabsolute", app.compassHandler, true);

                mapInstance.jumpTo({
                    center: [app.currentPos.coords.longitude, app.currentPos.coords.latitude],
                    padding: {
                        top: app.mapPadding
                    }
                });


                // reset map
                mapInstance.setBearing(app.mapbox.bearing);
                mapInstance.setPitch(app.mapPitch);

                let root = document.documentElement;
                root.style.setProperty('--user-dot-tilt', "0deg");
                root.style.setProperty('--user-dot-tilt-shadow', "none");

                this.compassActive = false;
                this.log('Compass stopped..');

            },
            compassHandler(e) {
                let app = this;
                app.compass = e.webkitCompassHeading || Math.abs(e.alpha - 360);

                let pitch = parseFloat(e.beta);
                if (pitch > 0 && pitch < 50) {
                    app.compassPitch = pitch;
                }

                let root = document.documentElement;
                root.style.setProperty('--user-dot-tilt', (360 - app.compassPitch) + "deg");

                let shadowSteps = Math.round(app.compassPitch / 10);
                let shadow = "";
                for (let i = 0; i < shadowSteps; i++) {
                    shadow += "0 " + (i + 1) + "px 0 1px #555,";
                }

                // 0 1px 0 1px, 0 2px 0 1px, 0 3px 0 1px, 0 4px 0 1px, 0 5px 0 1px
                root.style.setProperty('--user-dot-tilt-shadow', shadow.slice(0, -1));

                this.zoomBounds(true);


            },
            startCompass() {
                let app = this;
                if (this.getMobileOS() === 'iOS' && window.DeviceOrientationEvent && 'ontouchstart' in window) {
                    DeviceOrientationEvent.requestPermission()
                        .then((response) => {
                            if (response === "granted") {
                                app.compassActive = true;
                                window.addEventListener("deviceorientation", app.compassHandler, true);
                                //$('body').addClass('compass-active');
                                app.log("User accepted orientaion permission..");
                            } else {
                                app.log("User declined orientaion permission..");
                            }
                        })
                        .catch(() => app.log("iOS but DeviceOrientationEvent not supported.."));
                } else {
                    app.compassActive = true;
                    window.addEventListener("deviceorientationabsolute", app.compassHandler, true);
                    //$('body').addClass('compass-active');
                    app.log('Started compass but not iOS..');
                }

                // If on tipwalk, close ovarlay info
                if (this.isTipwalk) {
                    this.tipwalk.screen = null;
                }

                app.compassShowNotice = false;
            },
            showOfferMarker(offer) {
                let el = document.querySelector(this.rootEl + ' .offer-' + offer.postId);
                if (el) el.classList.add('active');
            },
            hideOfferMarker(store) {
                let el = document.querySelector(this.rootEl + ' .offer-' + store.postId);
                if (el) el.classList.remove('active');
            },
            locationUpdateError(err) {
                // dont do anything on these errors..
            },
            updateAccuracy(crd) {
                let app = this;
                let accuracy = crd.accuracy;
                let speed = crd.speed;

                this.accuracyArr.push(Math.round(accuracy));

                // Set a delay to let the geo position to settle
                let positionWaitCount = this.useWatchPosition ? 8 : 4;

                // If we dont have 5 location checks yet, use the default threshold
                // The first geolocatons has often way to bad accuracy
                if (this.accuracyArr.length < positionWaitCount) {
                    this.log('Default threshold.. ' + this.acceptedAccuracy + ' (' + this.accuracyArr.length + ')');
                    return this.acceptedAccuracy;
                }


                // Check for bad accuracy (Replaced by rankPosition function)
                //let bad = this.checkBadAccuracy();

                // Calculate average of last 5 items
                let lastAccuracys = this.accuracyArr.slice(-5);
                this.log(lastAccuracys.join());
                let newAccuracy = this.median(lastAccuracys);

                // Stop at max value
                if (newAccuracy > this.acceptedAccuracyMax) {
                    newAccuracy = this.acceptedAccuracyMax;
                }


                // If traveling in speed, add a marginal for that
                this.log('Seconds since last geo result: ' + this.locationAgo);

                if (speed) {
                    let speedMargin = Math.floor(speed) * this.locationAgo;
                    if (speedMargin > 0) {
                        newAccuracy += speedMargin;
                    }
                    this.log('Added speed margin: ' + speedMargin + 'm');
                }
                // Reset and restart location ago timer
                clearInterval(this.locationAgoIntervall);
                this.locationAgo = 0;
                this.locationAgoIntervall = setInterval(function () {
                    app.locationAgo++;
                }, 1000);

                // Make sure we are above minimum
                if (newAccuracy < this.acceptedAccuracyMin) {
                    newAccuracy = this.acceptedAccuracyMin;
                }

                // Update user point accuracy radius based on zoom level
                let zoom = Math.round(mapInstance.getZoom());
                let lat = this.currentPos.coords.latitude;
                let arrIndex = 0;

                // check what latitude we are at and decide which index in distance array we should use
                if (lat >= 20 || lat <= -20) {
                    arrIndex = 1;
                }
                if (lat >= 40 || lat <= -40) {
                    arrIndex = 2;
                }
                if (lat >= 60 || lat <= -60) {
                    arrIndex = 3;
                }
                if (lat >= 80 || lat <= -80) {
                    arrIndex = 4;
                }

                // Get distance per pixel from array
                let metersPerPixel = this.distanceArr[zoom.toString()][arrIndex];
                let accuracyRadius = Math.round((this.accuracy / metersPerPixel) * 2); // Times 2 to get circle
                let accuracyRadiusMedian = Math.round((newAccuracy / metersPerPixel) * 2);

                let root = document.documentElement;
                root.style.setProperty('--accuracy-size', accuracyRadius + "px");
                root.style.setProperty('--accuracy-median', accuracyRadiusMedian + "px");

                this.log('New accuracy threshold: ' + newAccuracy);


                // Return new accepted accuracy
                return newAccuracy;
                //return accuracy;
            },
            median(values) {
                if (values.length === 0) return 0;

                values.sort(function (a, b) {
                    return a - b;
                });

                const half = Math.floor(values.length / 2);

                if (values.length % 2)
                    return values[half];

                return (values[half - 1] + values[half]) / 2.0;
            },


            addUserLocation() {
                let app = this;

                // If no marker exist, add one
                if (!this.userMarker) {
                    // Add marker for user position
                    let el = document.createElement("div");
                    jQuery(el).append('<div class="user-marker"><div class="dot"><div class="circle"></div><div class="viewer"><div class="eye"></div></div></div></div>');

                    this.userMarker = new mapboxgl.Marker(el)
                        .setLngLat([app.currentPos.coords.longitude, app.currentPos.coords.latitude])
                        .addTo(mapInstance);

                } else {
                    this.updateUserPoint(app.currentPos.coords.longitude, app.currentPos.coords.latitude);
                }

                // Zoom into position
                if (this.autoZoomPosition) {
                    this.zoomBounds();
                }
            },
            updateUserPoint(lng, lat) {
                let app = this;

                if (this.userMarker) {

                    // For now, lets use animated user movement on demo mode only

                    this.userMarker.setLngLat([lng, lat]);


                    // Animate marker smoothly
                    if(this.isDemo){

                        return;

                        // Match 30fps, should be smooth enough on small movements
                        let FPS = 30 * (app.trackingInterval / 1000);

                        // Create a path with turf so that we can animate user point changes in a smooth way.
                        let from = this.userMarker.getLngLat();

                        // Get distance wo we can calculate the length along the line
                        let pointFrom = turfHelpers.point([from.lng, from.lat]);
                        let pointTo = turfHelpers.point([lng, lat]);
                        let options = { units: "meters" };
                        let distance = turfDistance(pointFrom, pointTo, options);
                        let chunkSize = distance / FPS;

                        let line = turfHelpers.lineString([[from.lng, from.lat],[lng, lat]]);
                        let chunks = turfLineChunk(line, chunkSize, { units: "meters" });

                        let coors = [
                            chunks.features[0].geometry.coordinates[0]
                        ];
                        // Get coordinates that we shall animate along
                        chunks.features.forEach(function (chunk){
                            coors.push(chunk.geometry.coordinates[1]);
                        });

                        // Clear any previous animation intervals
                        if(this.userDotAnimationIntervall) clearInterval(this.userDotAnimationIntervall);

                        // Setup new interval for animation
                        // Use tracking interval as base to get the dot to constantly move
                        this.userDotAnimationIntervall = setInterval(() => {
                            if(coors.length > 0){
                                let coord = coors.shift();
                                app.userMarker.setLngLat(coord);
                            } else {
                                if(app.userDotAnimationIntervall) clearInterval(app.userDotAnimationIntervall);
                            }
                        }, app.trackingInterval / FPS);

                    }



                }

            },
            zoomBounds(instant = false, force = false) {
                let app = this;


                // If bad accuracy, dont zoom
                if(app.isBadAccuracy && !force) return;

                // Check for bounds
                let tempBounds = [];

                // Add current position to bounds if not to far away
                if (!app.isBadAccuracy && app.currentPos.coords && app.showUserMarker && app.userMarker) {

                    // Check the user distance to the absolute center
                    let from = turfHelpers.point([app.currentPos.coords.latitude, app.currentPos.coords.longitude]);
                    let to = turfHelpers.point([app.mapbox.lat, app.mapbox.lng]);
                    let options = { units: "kilometers" };

                    let distance = turfDistance(from, to, options);

                    //console.log('Distance to center: ' + distance + 'km')

                    // If closer than 2km, add to bounds
                    if(distance < 2){
                        this.userIsInBounds = true;
                        tempBounds.push([this.currentPos.coords.longitude, this.currentPos.coords.latitude]);
                    } else {
                        // If to far away, center map
                        this.userIsInBounds = false;
                    }

                }

                // If store is active add to bounds
                if (app.mapbox.activeFeature && app.mapbox.activeFeature.hasOwnProperty('coordinates')) {
                    tempBounds.push([app.mapbox.activeFeature.coordinates.lng, app.mapbox.activeFeature.coordinates.lat]);
                }

                // If services is active add to bounds
                if (app.services.active.length) {
                    app.services.source.forEach(function (service) {
                        // Only parse active
                        if (app.services.active.includes(service.slug) && service.positions) {
                            service.positions.forEach(function (pos) {
                                if (pos.lat && pos.lng) {
                                    tempBounds.push([pos.lng, pos.lat]);
                                }
                            })
                        }
                    });
                }

                // If tipwalk, add next marker plus current pos to bounds
                if (app.isTipwalk) {
                    let nextpointPos = this.settings.tipwalk.positions[this.tipwalk.answers.length].question.position;
                    tempBounds.push([parseFloat(nextpointPos.lng), parseFloat(nextpointPos.lat)]);

                    // Add previous question if bad accuracy
                    if(app.isBadAccuracy && this.tipwalk.answers.length){
                        let prevPoint = this.settings.tipwalk.positions[this.tipwalk.answers.length - 1].question.position;
                        tempBounds.push([parseFloat(prevPoint.lng), parseFloat(prevPoint.lat)]);
                    }
                }

                // If no bounds, add default center
                if (!tempBounds.length) {
                    tempBounds.push([app.mapbox.lng, app.mapbox.lat]);
                }

                // Reset and add new bounds (https://docs.mapbox.com/mapbox-gl-js/example/zoomto-linestring/)
                this.mapbox.bounds = tempBounds.reduce(function (bounds, coord) {
                    return bounds.extend(coord);
                }, new mapboxgl.LngLatBounds(tempBounds[0], tempBounds[0]));

                let zoomDuration = instant ? 0 : 1000;

                // Disable interactivity when zooming if following user
                if (app.autoZoomPosition) {
                    this.setMapInteractivity('off');
                    setTimeout(function () {
                        app.setMapInteractivity('on');
                    }, zoomDuration);
                }

                let mapBearing = this.kioskBearing ? this.kioskBearing : app.mapbox.bearing;


                // If doing instant placement (compass) set top padding to get the point at lower part of screen
                if (instant) {

                    mapInstance.jumpTo({
                        center: [app.currentPos.coords.longitude, app.currentPos.coords.latitude],
                        pitch: app.compassPitch,
                        bearing: app.compass,
                        padding: {
                            top: Math.round((window.innerHeight / 3) * 2)
                        },
                        zoom: [18]
                    });


                    // this.log('Zoom: ' + zoom + ' - ' + mapInstance.getZoom());

                } else {
                    // Make sure not to zoom to much
                    mapInstance.fitBounds(app.mapbox.bounds, {
                        maxZoom: app.mapMaxZoom,
                        pitch: this.mapPitchFocused,
                        bearing: mapBearing,
                        maxBounds: app.mapbox.boundsOuter,
                        duration: zoomDuration,
                        essential: true,
                        padding: {
                            top: app.mapPadding,
                            bottom: app.mapPadding,
                            left: app.leftPadding,
                            right: app.mapPadding
                        }
                    });
                }

            },
            getStoreFloor(store) {
                let app = this;
                let fl = app.activeFloorIndex; // Default to current floor index

                // Get floor index from the floor number
                // If multiple floors exists, use default or first
                let hasMultiple = false;
                app.settings.areaData.forEach(function (floor, floorIndex) {
                    if(!floor.stores) return;

                    floor.stores.forEach(function (item) {
                        if (parseFloat(item.store) === store.postId) {

                            if (hasMultiple) {
                                // If found on multiple floors, only override if current floor
                                if (floorIndex === app.activeFloorIndex) {
                                    fl = floorIndex;
                                }
                            } else {
                                fl = floorIndex;
                            }
                            hasMultiple = true;
                        }
                    });
                });

                return fl;

            },
            setMapInteractivity(mode) {
                if (mode === 'off') {
                    mapInstance.boxZoom.disable();
                    mapInstance.scrollZoom.disable();
                    mapInstance.dragPan.disable();
                    mapInstance.dragRotate.disable();
                    mapInstance.keyboard.disable();
                    mapInstance.doubleClickZoom.disable();
                    mapInstance.touchZoomRotate.disable();
                } else {
                    mapInstance.boxZoom.enable();
                    mapInstance.scrollZoom.enable();
                    mapInstance.dragPan.enable();
                    mapInstance.dragRotate.enable();
                    mapInstance.keyboard.enable();
                    mapInstance.doubleClickZoom.enable();
                    mapInstance.touchZoomRotate.enable();
                }
            },
            zoomToStore() {
                let app = this;
                let activeDelay = 0; // Delay of active state if changing floor

                // If no active store, exit

                //console.log(app.activeStore);
                //console.log(app.activeStore.postId);

                if(!app.activeStore.postId) return;


                // Check if we should update floor
                let floor = this.getStoreFloor(app.activeStore);
                if (this.activeFloorIndex !== floor) {
                    this.setFloor(floor);
                    activeDelay = 200;
                }


                // Reset any prior markers
                this.resetAllMarkers();

                // Hide any shown offers on current store
                this.toggleStoreOffers();

                // Get feature
                let feature = app.settings.areaData[app.activeFloorIndex].stores.filter(function (item) {
                    return parseInt(item.store) === parseInt(app.activeStore.postId);
                });

                this.mapbox.activeFeature = feature[0];

                let source;
                if (app.mapbox.activeFeature && app.mapbox.activeFeature.hasOwnProperty('layer')) {
                    source = app.mapbox.activeFeature.layer.source;
                } else {
                    source = 'floor-' + app.activeFloorIndex;
                }


                // When changing floor we need to wait a bit for this to take effect
                setTimeout(function () {
                    mapInstance.setFeatureState({
                        source: source,
                        id: parseInt(feature[0].id)
                    }, {
                        hover: true,
                    });
                }, activeDelay);


                // Reset hover store
                this.storeIsHovered = false;



                // Update source layer for extrusion height update
                mapInstance
                    .getSource(app.getActiveStoreLayer())
                    .setData(app.getStoresGeoData(app.activeFloorIndex));

                // Activate marker on this store
                let markers = document.querySelectorAll(this.rootEl + ' .marker-store.store-' + app.activeStore.postId);
                if (markers) {
                    markers.forEach((m) => m.classList.add('active'));
                    markers.forEach((m) => m.classList.remove('hover'));
                }


                // If not in 3d already, set it here
                if (!this.use3d) {
                    this.toggle3d(true);
                }



                app.$nextTick(function() {
                    if(!app.activeStore){
                        this.log('No active store set, exit');
                        return;
                    }
                    gsap.to(app.rootEl + ' .marker-store.store-' + app.activeStore.postId + '.floor-' + app.activeFloorIndex + ' .inner', {
                        yPercent: -80,
                        opacity: 1,
                        delay: 0,
                        duration: 0.3,
                        ease: 'power4.out',
                        onComplete: app.checkActiveMarker, // Make sure marker ist still active after animation ready
                        onCompleteParams: [app.activeStore.postId]
                    })
                });


                // Hide store label/logo since main marker is active
                let label = document.querySelector(this.rootEl + ' .store-label-' + app.activeStore.postId);
                if (label) label.classList.add('inactive');


                // If kiosk, draw route
                if(app.isKiosk){
                    app.drawRoute();
                }


                // Zoom map into location
                this.zoomBounds();

            },
            checkActiveMarker(storeId) {
                if(!this.activeStore || storeId !== this.activeStore.postId) {
                    gsap.set(this.rootEl + ' .marker-store.store-' + storeId + ' .inner', {yPercent: 0, opacity: 0});
                }
            },
            hoverStore(featureId) {
                let app = this;

                // Do not hover active stores
                if (app.mapbox.activeFeature) {
                    if (this.activeStore && featureId === parseInt(app.mapbox.activeFeature.id)) {
                        this.log('nope..');
                        return;
                    }
                }


                if (!this.storeIsHovered) {
                    // Check what store we are working with

                    let store = app.getStoreFromFeature(featureId);

                    if (store) {

                        this.storeIsHovered = store.postId;
                        let marker = document.querySelector(this.rootEl + ' .marker-store.store-' + store.postId + '.floor-' + app.activeFloorIndex);
                        if (marker) marker.classList.add('hover');

                        // Hide store label since main marker is active
                        let label = document.querySelector(this.rootEl + ' .store-label-' + store.postId + '.floor-' + app.activeFloorIndex);
                        if (label) label.classList.add('inactive');

                        // Temporary hide any offers when hovering a store
                        app.toggleStoreOffers(store.postId);

                    } else {
                        this.log('No store set..');
                    }

                }
            },
            unHoverStore(featureId) {
                let app = this;

                if (this.storeIsHovered) {

                    // Hide store label since main marker is active
                    if (this.activeStore && this.storeIsHovered === this.activeStore.postId) {
                        return;
                    }

                    let marker = document.querySelector(this.rootEl + ' .marker-store.store-' + this.storeIsHovered + '.floor-' + app.activeFloorIndex);
                    if (marker) marker.classList.remove('hover');

                    let label = document.querySelector(this.rootEl + ' .store-label-' + this.storeIsHovered + '.floor-' + app.activeFloorIndex);
                    if (label) label.classList.remove('inactive');


                    this.storeIsHovered = false;

                    // Reset any hidden offers
                    app.toggleStoreOffers(0, true)
                }
            },
            getActiveStoreLayer() {
                let app = this;
                let source = false;
                if (app.mapbox.activeFeature && app.mapbox.activeFeature.hasOwnProperty('layer')) {
                    source = app.mapbox.activeFeature.layer.source;
                } else {
                    source = 'floor-' + app.activeFloorIndex;
                }

                return source;
            },
            resetMap() {
                let app = this;

                if(!mapInstance) return;

                // Add all area coordinates to create our outer bounds

                app.centerMap();

                // If kiosk, remove route
                if(app.isKiosk){
                    if (mapInstance.getLayer('routeLineLayer')) {
                        mapInstance.setPaintProperty('routeLineLayer', 'line-opacity', 0);
                        mapInstance.setPaintProperty('routeLineLayerBelow', 'line-opacity', 0);
                        //mapInstance.setPaintProperty('routeEndMarkerLayer', 'line-opacity', 0);
                    }
                }


                // TODO - Dont do this on init..
                this.resetAllMarkers();

                // Reset sidebar
                //this.setScene('list');
                this.$nextTick(function() {
                    app.mapbox.activeFeature = null;
                    app.activeStore = null;
                });

            },
            centerMap(){
                let app = this;

                // If bad accuracy, dont do anything
                if(app.isBadAccuracy) return;

                let tempBounds = this.getAllFeatureCoordinates();


                // Reset and add new bounds (https://docs.mapbox.com/mapbox-gl-js/example/zoomto-linestring/)
                this.mapbox.bounds = tempBounds.reduce(function (bounds, coord) {
                    return bounds.extend(coord);
                }, new mapboxgl.LngLatBounds(tempBounds[0], tempBounds[0]));


                // Make sure not to zoom to much
                mapInstance.fitBounds(app.mapbox.bounds, {
                    maxZoom: app.mapMaxZoom,
                    pitch: app.mapPitchFocused,
                    bearing: app.mapbox.bearing,
                    duration: 1000,
                    essential: true,
                    padding: {
                        top: app.mapPadding,
                        bottom: app.mapPadding,
                        left: app.leftPadding,
                        right: app.mapPadding
                    }
                });
            },
            resetFeature(feature, source = false) {
                let app = this;

                if (!feature) return;

                if (!source) {
                    source = this.getActiveStoreLayer();
                }


                mapInstance.setFeatureState({
                    source: source,
                    id: parseInt(feature.id)
                }, {
                    hover: false,
                });
            },
            resetAllFeatures(){
                let app = this;

                // Parse all floor layers
                this.mapbox.sources.forEach(function (source, i) {

                    // Parse All features
                    mapInstance.querySourceFeatures(source).forEach(function (feature, i) {
                        mapInstance.setFeatureState({
                            source: source,
                            id: parseInt(feature.id)
                        }, {
                            hover: false,
                        });
                    });

                });
            },

            resetAllMarkers() {
                let app = this;


                // Parse all floor layers
                this.mapbox.sources.forEach(function (source, i) {

                    // Reset store heights for current floor
                    if (source === 'floor-' + app.activeFloorIndex) {
                        mapInstance
                            .getSource(source)
                            .setData(app.getStoresGeoData(app.activeFloorIndex, true));
                    }

                });


                app.resetAllFeatures();


                // Inactivate all markers
                gsap.set(app.rootEl + ' .marker-store .inner', {yPercent: 0, opacity: 0});

                // Remove active class
                let markers = document.querySelectorAll('.marker-store');
                markers.forEach((el) => el.classList.remove('active'));

                // Reset any inactive label
                let labels = document.querySelectorAll(this.rootEl + ' .marker-store-label');
                labels.forEach((el) => el.classList.remove('inactive'));

                // Make sure to hide all markers thats not on our floor
                labels.forEach(function(el){

                  if(!el.classList.contains('floor-' + app.activeFloorIndex)){
                      el.classList.add('inactive');
                  }
                })



            },
            checkFloorIndexFromLabel(label) {


                let i = 0;
                for (const floor of this.settings.floorData) {
                    if (parseInt(floor.info.num) === parseInt(label)) {
                        return i;
                    }
                    i++;
                }

                return 0;
            },
            setBearing(deg) {
                let app = this;
                //if (this.mapIsAnimating) return;
                if (deg === 0 && mapInstance.getBearing() === 0) {
                    deg = this.mapbox.bearing;
                }
                //this.mapIsAnimating = true;
                mapInstance.rotateTo(deg, {duration: 0});
                //setTimeout(() => app.mapIsAnimating = false, 1000);
            },
            initMap() {
                let app = this;

                // If called twice, return
                if(mapInstance) return;

                mapboxgl.accessToken = this.mapbox.token;

                //this.setMaxBounds();

                // Check for Android, since it handles gelocation a bit differently
                if (/Android/i.test(navigator.userAgent)) {
                    this.isAndroid = true;
                    this.useWatchPosition = true;
                }


                let settings = {
                    container: 'store-map-' + app.unique, // container ID
                    style: app.mapbox.styles[0], // style URL
                    center: [app.mapbox.lng, app.mapbox.lat], // starting position [lng, lat]
                    zoom: app.mapMinZoom, // starting zoom
                    minZoom: 10, // starting zoom
                    maxZoom: app.mapMaxZoom, // starting zoom
                    bearing: app.mapbox.bearing,
                    pitch: app.mapPitch,
                    //maxBounds: app.mapbox.boundsOuter,


                    // Interaction settings
                    cooperativeGestures: true,
                    scrollZoom: true,
                    boxZoom: true,
                    dragRotate: true,
                    dragPan: true,
                    keyboard: false,
                    doubleClickZoom: true,
                    touchZoomRotate: true,
                    touchPitch: true,

                    // Language
                    locale: {
                        "ScrollZoomBlocker.CtrlMessage": "Använd ctrl + skroll för att zooma i kartan",
                        "ScrollZoomBlocker.CmdMessage": "Använd ⌘ + skroll för att zooma i kartan",
                        "TouchPanBlocker.Message": "Använd två fingrar för att navigera i kartan",
                    },
                };


                // When in fullscreen lightbox, no need for cooperative gestures
                if (this.widgetSettings.view === 'tipwalk' || this.widgetSettings.lightbox) {
                    settings.cooperativeGestures = false;
                }


                mapInstance = new mapboxgl.Map(settings);

                app.mapbox.map = mapInstance;

                mapInstance.on('load', () => {



                    // Set some standard style settings
                    app.setStandardStyleDefaults();


                    // add a geojson source with a polygon to be used in the clip layer.
                    mapInstance.addSource('eraser', {
                        'type': 'geojson',
                        'data': mapAppSettings.mapExclude
                    });

                    mapInstance.addLayer({
                        'id': 'eraser',
                        'type': 'clip',
                        'source': 'eraser',
                        'layout': {
                            // specify the layer types to be removed by this clip layer
                            'clip-layer-types': ['symbol', 'model'],
                            'clip-layer-scope': ['basemap']
                        }
                    });

                    // add a line layer to visualize the clipping region.
                    /*
                    mapInstance.addLayer({
                        'id': 'eraser-debug',
                        'type': 'line',
                        'source': 'eraser',
                        'paint': {
                            'line-color': 'rgba(255, 0, 0, 0.9)',
                            'line-dasharray': [0, 4, 3],
                            'line-width': 5
                        }
                    });
                    */



                    // Parse data for each floor
                    app.settings.floorData.forEach(function (floor, i) {


                        // Extra areas
                        if (JSON.parse(floor.geojson_other)) {



                            let layerExtraId = 'floor-extra-' + i;
                            let layerExtraName = 'layer-' + layerExtraId;

                            app.mapbox.sources.push(layerExtraId);
                            app.mapbox.layers.push(layerExtraName);

                            mapInstance.addSource(layerExtraId, {
                                type: 'geojson',
                                data: JSON.parse(floor.geojson_other),
                            });

                            mapInstance.addLayer({
                                'id': layerExtraName,
                                'source': layerExtraId,
                                'type': 'fill',
                                'paint': {
                                    'fill-color': [
                                        'case',
                                        ['boolean', ['feature-state', 'hover'], false],
                                        app.settings.colors.active_other,
                                        app.settings.colors.inactive_other,
                                    ],
                                },
                                'layout': {
                                    'visibility': 'none', // none | visible
                                },
                                slot: 'top'
                            });
                        }


                        let geoJsonStores = JSON.parse(floor.geojson);


                        // Loop features and add some data
                        /*
                        geoJsonStores.features.forEach(function (feature, i) {
                          feature.properties.hoverColor = 2000;
                        });
                         */

                        //console.log('floor.geojson');
                        //console.log(geoJsonStores);


                        // Stores

                        let layerId = 'floor-' + i;
                        let layerName = 'layer-' + layerId;

                        app.mapbox.sources.push(layerId);
                        app.mapbox.layers.push(layerName);

                        mapInstance.addSource(layerId, {
                            type: 'geojson',
                            data: geoJsonStores,
                        });


                        mapInstance.addLayer({
                            'id': layerName,
                            'source': layerId,
                            'type': 'fill-extrusion',
                            'minzoom': app.mapMinZoom,
                            'layout': {
                                // Hide by default and let our current settings update visibility
                                'visibility': 'none', // none | visible
                            },
                            'paint': {
                                'fill-extrusion-color': [
                                    'case',
                                    ['boolean', ['feature-state', 'hover'], false],
                                    app.settings.colors.active,
                                    app.settings.colors.inactive,
                                ],
                                'fill-extrusion-height': ["number", ["get", "height"], 10],
                                'fill-extrusion-base': ["number", ["get", "min_height"], 0],
                                'fill-extrusion-opacity': 1,
                                'fill-extrusion-height-transition': {
                                    duration: 2000,
                                    delay: 0
                                },

                                // GL3 features
                                //'fill-extrusion-edge-radius': 1,
                            },
                            slot: 'top'
                        });

                    })


                    // Direction layer
                    /*
                                    const line = turf.lineString(window.lineGeoJson);

                                    const curved = turf.bezierSpline(line, {sharpness: 0.5});

                                    mapInstance.addSource('lines', {
                                        type: 'geojson',
                                        data: curved,
                                    });
                    */


                    // Add service markers to map
                    for (const serviceMarker of app.settings.serviceData) {
                        // Inside each service we might have multiple position markers
                        for (const point of serviceMarker.positions) {

                            // create a HTML element for each feature
                            let el = document.createElement('div');
                            el.className = 'marker-service ' + serviceMarker.slug;
                            el.className += ' floor-' + app.checkFloorIndexFromLabel(point.floor);
                            el.innerHTML += '<div class="inner">' + serviceMarker.icon + '</div>';

                            // make a marker for each feature and  add to the map
                            new mapboxgl.Marker(el).setLngLat([point.lng, point.lat]).addTo(mapInstance);

                        }
                    }


                    // Add custom markers to map
                    for (const customMarker of app.settings.markersData) {
                        // Inside each service we might have multiple position markers
                        for (const point of customMarker.positions) {

                            // create a HTML element for each feature
                            let el = document.createElement('div');
                            el.className = 'marker-custom ' + customMarker.slug;
                            el.className += ' floor-' + app.checkFloorIndexFromLabel(point.floor);

                            if (customMarker.title.length > 0) {
                                el.innerHTML += '<div class="inner">' + customMarker.icon + '<span>' + customMarker.title + '</span></div>';
                            } else {
                                el.innerHTML += '<div class="inner">' + customMarker.icon + '</div>';
                            }

                            // Sticky?
                            if (point.sticky) el.className += ' sticky-marker';

                            // make a marker for each feature and  add to the map
                            new mapboxgl.Marker(el).setLngLat([point.lng, point.lat]).addTo(mapInstance);

                        }
                    }


                    // Add store markers and labels to map
                    app.settings.areaData.forEach(function (floor, floorIndex) {

                        if(floor.hasOwnProperty('stores') && floor.stores.length) {

                            floor.stores.forEach(function (area) {

                                if (area.store && area.coordinates) {
                                    // -- Label marker
                                    let label = document.createElement('div');
                                    label.className = 'marker-store-label store-label-' + area.store + ' floor-' + floorIndex;

                                    // data from store
                                    let store = app.settings.storeData.filter(function (item) {
                                        if (item.postId === parseFloat(area.store)) {
                                            return true;
                                        }
                                    });
                                    store = store[0];

                                    if (!store) return;

                                    let labelContent = '<span class="store-name">' + store.title + '</span>';
                                    // Sticky?
                                    if (area.sticky && area.sticky === 'true') label.className += ' sticky-marker';

                                    // Logo instead of title?
                                    if (area.stickyLogo && area.stickyLogo === 'true') {
                                        label.className += ' sticky-logo';
                                        labelContent = '<img class="logo" src="' + store.logo + '">';
                                    }

                                    label.innerHTML += '<div class="inner">' + labelContent + '</div>';


                                    // -- Focus marker
                                    let marker = document.createElement('div');
                                    marker.className = 'marker-store store-' + area.store + ' floor-' + floorIndex;
                                    marker.innerHTML += '<div class="inner"><img class="img" src="' + store.image + '"><div class="txt"><h4 class="store-name">' + store.title + '</h4><a class="link" href="' + store.url + '">Till verksamheten</a></div></div>';
                                    new mapboxgl.Marker(marker).setLngLat([area.coordinates.lng, area.coordinates.lat]).addTo(mapInstance);

                                    // -- Add label here to get placed under focused label
                                    new mapboxgl.Marker(label).setLngLat([area.coordinates.lng, area.coordinates.lat]).addTo(mapInstance);

                                }

                            });
                        }


                        // Add other areas labels
                        if (floor.hasOwnProperty('other') && floor.other.length) {
                            floor.other.forEach(function (area) {

                                if (area.otherLabel && area.coordinates) {

                                    // -- Label marker
                                    let label = document.createElement('div');
                                    label.className = 'marker-other-label other-label-' + area.store + ' floor-' + floorIndex;

                                    // Sticky?
                                    if (area.sticky && area.sticky === 'true') label.className += ' sticky-marker';

                                    label.innerHTML += '<div class="inner"><span class="store-name">' + area.otherLabel + '</span></div>';
                                    new mapboxgl.Marker(label).setLngLat([area.coordinates.lng, area.coordinates.lat]).addTo(mapInstance);
                                }

                            });
                        }


                    });


                    // Add offer markers to map
                    app.settings.offers.forEach(function (offer) {


                        // Only add if we have coordinates
                        if (!offer.coordinates || !offer.coordinates.length) return;

                        // Add the connected store id as class so we can toggle visibility when store is active
                        let storeClass = '';
                        if (Array.isArray(offer.stores)) {
                            offer.stores.forEach(function (storeId) {
                                storeClass += ' store-offer-' + storeId;
                            });
                        }

                        offer.coordinates.forEach(function (coor) {

                            // -- Custom marker
                            let el = document.createElement('div');
                            el.className = 'marker-offer offer-' + offer.postId + ' floor-' + coor.floor + storeClass;
                            //el.innerHTML += '<div class="inner"><img class="img" src="' + offer.image + '"><div class="txt"><h4 class="title">' + offer.title + '</h4></div></div>';
                            el.innerHTML += '<div class="inner"><i class="icon icon-sale"></i><div class="txt"><h4 class="title">Kampanj</h4></div></div>';

                            new mapboxgl.Marker(el).setLngLat([coor.lng, coor.lat]).addTo(mapInstance);
                        });
                    });


                    // Handle mouse events
                    let fHover;
                    mapInstance.on('mousemove', function (e) {

                        // Dont do hover effect on mobile
                        if (app.mobile) return;

                        // If tipwalk dont respond to this
                        if (app.isTipwalk) return;

                        let features = mapInstance.queryRenderedFeatures(e.point, {
                            layers: app.mapbox.layers
                        });

                        if (features[0]) {
                            mouseout();
                            mouseover(features[0]);
                        } else {
                            mouseout();
                        }

                    });

                    function mouseover(feature) {
                        fHover = feature;

                        // If tipwalk dont respond to this
                        if (app.isTipwalk) return;


                        if (app.mapbox.activeFeature && feature.id === parseInt(app.mapbox.activeFeature.id)) {
                            return;
                        }


                        app.hoverStore(feature.id);

                        mapInstance.getCanvasContainer().style.cursor = 'pointer';


                        // Set active state to building
                        mapInstance.setFeatureState({
                            source: feature.layer.source,
                            id: fHover.id
                        }, {
                            hover: true,
                        });
                    }


                    function click(e) {

                        // If tipwalk dont respond to this
                        if (app.isTipwalk) return;

                        var features = mapInstance.queryRenderedFeatures(e.point, {
                            layers: app.mapbox.layers
                        });

                        if (features[0]) {

                            app.mapbox.activeFeature = features[0];

                            // Get area info
                            // First, check for stores
                            let store = app.getStoreFromFeature(features[0].id);

                            if (store) {
                                // Open store
                                app.openStore(store);
                            } else {

                                // If no Stores found, check for other areas
                                if (app.settings.areaData[app.activeFloorIndex].other) {
                                    for (let obj of app.settings.areaData[app.activeFloorIndex].other) {
                                        if (parseInt(features[0].id) === parseInt(obj.id)) {
                                            app.openOther(obj)
                                            break;
                                        }
                                    }
                                }
                            }

                        } else {
                            // If no feature found, make sure to inactivate any current
                            app.deactivateAreas();
                        }

                    }

                    // Listen for touch/click
                    mapInstance.on('click', function (e) {
                        click(e);
                    });
                    /*
                    if(app.mobile){
                        mapInstance.on('touchend', function (e) {
                            click(e);
                        });
                    } else {

                    }
                    */


                    mapInstance.on('mouseout', function (e) {
                        mouseout();
                    });

                    function mouseout() {
                        if (!fHover) return;

                        // If tipwalk dont respond to this
                        if (app.isTipwalk) return;

                        // Do not disable if active from before
                        if (app.mapbox.activeFeature && fHover.id === parseFloat(app.mapbox.activeFeature.id)) return;

                        mapInstance.getCanvasContainer().style.cursor = 'default';

                        app.unHoverStore(fHover.id);

                        // Set active state to building
                        mapInstance.setFeatureState({
                            source: fHover.layer.source,
                            id: fHover.id
                        }, {
                            hover: false
                        });
                    }


                    // Update some stuff on every zoom
                    mapInstance.on('zoom', () => {

                        let zoom = mapInstance.getZoom();
                        let labelSize = (zoom / 15) * 10;
                        let logoSize = app.getLogoSize(zoom);


                        let el = document.querySelector(app.rootEl);
                        el.style.setProperty('--map-store-label-size', labelSize + 'px');
                        el.style.setProperty('--map-store-logo-size', logoSize + 'px');

                        // Hide label on zoomed out
                        if (zoom > app.mapMaxZoom - 1) {
                            el.style.setProperty('--map-store-label-opacity', '0.8');
                            el.style.setProperty('--map-custom-marker-opacity', '1');
                        } else {
                            el.style.setProperty('--map-store-label-opacity', '0');
                            el.style.setProperty('--map-custom-marker-opacity', '0');
                        }

                        // Hide logos when zoomed out
                        if (zoom > 16.2) {
                            el.style.setProperty('--map-store-logo-opacity', '1');
                        } else {
                            el.style.setProperty('--map-store-logo-opacity', '0');
                        }


                    });


                    // When map is ready to use, lets look for initial actions,
                    // such as zooming in on store on start etc..
                    // We need all our floor layers to be ready before doing anything.. let's add a listener for it!

                    mapInstance.on('sourcedata', (e) => {
                        //console.log(e);

                        if (e.sourceId === app.mapbox.sources[app.mapbox.sources.length - 1] && !app.mapIsLoaded) {
                            app.mapIsLoaded = true;
                            app.doInitialStuff();
                        }
                    });



                    // When dragging, check that we keep ourselves withing bounds

                    mapInstance.on('dragend', () => {
                        app.ifOutOfBounds();
                    });

                    /*
                                        // Turf test to show outer bounds
                                        mapInstance.addSource('mylayer', {
                                            type: 'geojson',
                                            data: app.getOuterBounds()
                                        });
                                        mapInstance.addLayer({
                                            "id": "mylayer",
                                            "type": "fill",
                                            "source": "mylayer",
                                            'paint': {
                                                'fill-color': '#088',
                                                'fill-opacity': 0.2
                                            }
                                        });
                    */


                    // Add weather
                    if(this.widgetSettings.useSnow){

                        const zoomBasedSnowReveal = (value) => {
                            return [
                                'interpolate',
                                ['linear'],
                                ['zoom'],
                                11,
                                0.0,
                                13,
                                value
                            ];
                        };

                        mapInstance.setSnow({
                            density: zoomBasedSnowReveal(0.85),
                            intensity: 1.0,
                            'center-thinning': 0.1,
                            direction: [0, 50],
                            opacity: 1.0,
                            color: `#ffffff`,
                            'flake-size': 0.71,
                            vignette: zoomBasedSnowReveal(0.3),
                            'vignette-color': `#ffffff`
                        });

                    }

                });
            },
            setStandardStyleDefaults(){

                mapInstance.setConfigProperty('basemap', 'showPlaceLabels', false);
                mapInstance.setConfigProperty('basemap', 'showRoadLabels', true);
                mapInstance.setConfigProperty('basemap', 'showTransitLabels', false);
                mapInstance.setConfigProperty('basemap', 'showPointOfInterestLabels', false);

                if(this.widgetSettings.useSnow){
                    mapInstance.setConfigProperty('basemap', 'theme', 'monochrome');
                    mapInstance.setConfigProperty('basemap', 'lightPreset', 'day');
                } else {
                    mapInstance.setConfigProperty('basemap', 'lightPreset', 'day');
                    mapInstance.setConfigProperty('basemap', 'theme', 'monochrome');
                }


                /*
                // Update default full opacity of building to 0.6
                const currentStyle = mapInstance.getStyle();

                currentStyle.imports[0].data.layers.forEach(function (layer) {
                    if(layer.id === '3d-building'){
                        //this.log(layer.paint);
                        layer.paint['fill-extrusion-opacity'] = [
                            "interpolate",
                            [
                                "linear"
                            ],
                            [
                                "zoom"
                            ],
                            12,
                            0,
                            12.1,
                            0.6,
                        ];
                    }
                });

                // Set the updated style
                mapInstance.setStyle(currentStyle);
                */

            },
            setLightning(preset) {
                mapInstance.setConfigProperty('basemap', 'lightPreset', preset);
            },
            setTheme(preset) {
                mapInstance.setConfigProperty('basemap', 'theme', preset);
            },
            deactivateAreas() {
                let app = this;
                // Close any active stores
                //
                app.closeStore();
                // Set all features to inactive

                // Parse all floor layers
                this.mapbox.sources.forEach(function (source, i) {
                    app.resetFeature(app.mapbox.activeFeature, source);
                });

            },
            getLogoSize(zoom) {
                let z = 0;
                if (zoom <= 16) z = 0;
                if (zoom > 16) z = 2 * zoom;
                if (zoom > 17) z = 4 * zoom;
                if (zoom > 18) z = 6 * zoom;
                if (zoom > 19) z = 8 * zoom;
                if (zoom > 21) z = 10 * zoom;
                if (zoom > 22) z = 15 * zoom;

                return z;
            },
            getAllFeatureCoordinates() {
                let app = this;
                // Get all bounds
                let tempBounds = [];
                if (app.settings.areaData.length) {

                    app.settings.areaData.forEach(function (floor) {
                        if (floor.stores && floor.stores.length) {
                            floor.stores.forEach(function (store) {
                                if (!store.coordinates) return;
                                if (store.coordinates.lat && store.coordinates.lng) {
                                    tempBounds.push([store.coordinates.lng, store.coordinates.lat]);
                                }
                            })
                        }

                        if (floor.other && floor.other.length) {
                            floor.other.forEach(function (other) {
                                if (!other.coordinates) return;
                                if (other.coordinates.lat && other.coordinates.lng) {
                                    tempBounds.push([other.coordinates.lng, other.coordinates.lat]);
                                }
                            })
                        }
                    });

                }

                // If no bounds, add default center
                if (!tempBounds.length) {
                    tempBounds.push([app.mapbox.lng, app.mapbox.lat]);
                }

                return tempBounds;
            },
            setMaxBounds() {
                let app = this;


                // Get the coordinates from map using unproject since we have rotated the map.
                let canvas = mapInstance.getCanvas(),
                    w = canvas.width,
                    h = canvas.height,
                    cUL = mapInstance.unproject([0,0]).toArray(),
                    cUR = mapInstance.unproject([w,0]).toArray(),
                    cLR = mapInstance.unproject([w,h]).toArray(),
                    cLL = mapInstance.unproject([0,h]).toArray();

                let coordinates = [cUL,cUR,cLR,cLL,cUL];

                let bounds = new mapboxgl.LngLatBounds();

                coordinates.forEach(function(crd) {
                    /*
                    let marker = new mapboxgl.Marker();
                    marker.setLngLat(crd).addTo(mapInstance);
                    */
                    bounds.extend(crd);
                });

                /*
                let marker = new mapboxgl.Marker({
                    color: '#000'
                });
                marker.setLngLat(bounds.getCenter()).addTo(mapInstance);
                */
                this.mapbox.boundsOuter = bounds;

                //mapInstance.setMaxBounds(bounds);
            },
            getStoreFromFeature(featureId) {
                let app = this;

                if(app.settings.areaData[app.activeFloorIndex].hasOwnProperty('stores') && app.settings.areaData[app.activeFloorIndex].stores.length) {
                    for (let obj of app.settings.areaData[app.activeFloorIndex].stores) {
                        if (parseInt(featureId) === parseInt(obj.id)) {
                            if (obj.hasOwnProperty('store')) {

                                // Find store object and activate it
                                for (let store of app.settings.storeData) {
                                    if (parseInt(store.postId) === parseInt(obj.store)) {
                                        // Match
                                        return store;
                                    }
                                }
                            }
                            return;
                        }
                    }
                }
                return false;
            },
            /*
            showStickyLabels(){
                let app = this;
                // Add store markers and labels to map
                app.settings.storeData.forEach(function (storeMarker) {
                    // Only add if we have coordinates
                    if (!storeMarker.coordinates) return;

                    if(storeMarker.sticky === 'true') {
                        let label = document.querySelector(app.rootEl + ' .store-label-' + storeMarker.postId);
                        label.classList.add('sticky-marker');
                    }
                });
            },

             */
            doInitialStuff() {
                let app = this;
                this.log(this.widgetSettings);




                this.doKioskStuff();
                this.resetMap();
                this.resetSidebar();
                this.setFloor();
                this.updateServiceBtns();


                // Trigger resize event for map on orientation change -> https://dzone.com/articles/detecting-screen-orientation-in-javascript
                let portrait = window.matchMedia("(orientation: portrait)");
                portrait.addEventListener("change", function (e) {
                    setTimeout(() => app.triggerResize(), 200);
                });

                // Also set up a interval to do regular resize events
                setInterval(() => app.triggerResize(), 2000);

                // Add store labels
                //setTimeout(()=> app.showStickyLabels(), 1000);

                // Chill with initial actions to let reset function to take effect..
                setTimeout(function () {

                    // At this point the map has zoomed to its most zoomed out view necessary.. Lets create the outer bounds from this view
                    app.setMaxBounds();

                    app.showLoader = false;

                    // Focus store?
                    if (app.widgetSettings.view === 'single_store') {
                        let store = app.getStoreFromPostId(app.widgetSettings.store);
                        if (store) {
                            //console.log(store);

                            app.openStore(store);
                        }
                    }


                    // Focus service?
                    if (app.widgetSettings.view === 'service') {
                        app.toggle3d();
                        app.setScene('service');
                        app.toggleService(app.getServiceFromSlug(app.widgetSettings.service));
                    }


                    // Add a inital ready class to map
                    app.mapReady = true;

                    // Set 3d and do a initial zoom for the feels
                    app.toggle3d(true);

                    let center = mapInstance.getCenter();
                    let zoom = mapInstance.getZoom() + 0.4;

                    let bearing = this.use3d ? Math.round(mapInstance.getBearing()) + 5 : mapInstance.getBearing(); // tweek the map a bit to emphasise 3d viw


                    mapInstance.flyTo({
                        center: center,
                        zoom: zoom,
                        pitch: 30,
                        bearing: bearing,
                        duration: 2000,
                        essential: true
                    });




                    //document.querySelector(app.rootEl).classList.add('map-ready');


                    if (app.widgetSettings.view === 'experiment' && !document.getElementById('threebox-js')) {
                        let script = document.createElement('script')
                        script.setAttribute('src', 'https://d39637iv3eybjn.cloudfront.net/threebox.min.js')
                        script.setAttribute('id', 'threebox-js')
                        document.body.appendChild(script)

                        app.toggle3d();

                        // now wait for it to load...
                        script.onload = () => {

                            // Delay this so other maps on page wont slow down
                            setTimeout(() => {
                                app.startThreebox();
                            }, 3000)

                        }
                    }
                }, 500);


                if (this.isTipwalk) {
                    this.initTipWalk();
                    this.doTipwalkDev();
                }
            },
            doKioskStuff() {
                this.isKiosk = this.widgetSettings.view === 'kiosk';
                if(!this.isKiosk) return;

                this.showUserMarker = true;

                // Get location from settings
                this.currentPos = {
                    coords: {
                        latitude: parseFloat(this.widgetSettings.kiosk_lat),
                        longitude: parseFloat(this.widgetSettings.kiosk_lng),
                    }
                }
                // Fallback position
                if(!this.currentPos.coords.latitude || !this.currentPos.coords.longitude){
                    this.currentPos.coords.latitude = this.settings.coordinates.lat;
                    this.currentPos.coords.longitude = this.settings.coordinates.lng;
                }

                let root = document.documentElement;
                root.style.setProperty('--user-dot-tilt', (360 - this.mapPitch) + "deg");

                let shadowSteps = 3;
                let shadow = "";
                for (let i = 0; i < shadowSteps; i++) {
                    shadow += "0 " + (i + 1) + "px 0 1px #555,";
                }

                // 0 1px 0 1px, 0 2px 0 1px, 0 3px 0 1px, 0 4px 0 1px, 0 5px 0 1px
                root.style.setProperty('--user-dot-tilt-shadow', shadow.slice(0, -1));

                this.addUserLocation();

            },
            toggleShowRoute() {
                this.showRoute = !this.showRoute;

            },
            drawRoute() {
                let app = this;

                if(!this.showRoute) return;

                let storeCoords = [app.mapbox.activeFeature.coordinates.lng, app.mapbox.activeFeature.coordinates.lat];
                let kioskCoords = [app.currentPos.coords.longitude, app.currentPos.coords.latitude];
                const initialLine = turfHelpers.lineString([
                    [
                        13.424197263875612,
                        59.37921328778509
                    ],
                    [
                        13.424444245476735,
                        59.37903034254194
                    ],
                    [
                        13.424644546224556,
                        59.37891113243995
                    ],
                    [
                        13.424868977006895,
                        59.37875867402292
                    ],
                    [
                        13.424910434256105,
                        59.378701892920475
                    ],
                    [
                        13.425072960421915,
                        59.37864433032385
                    ],
                    [
                        13.425253899737328,
                        59.378499544209745
                    ],
                    [
                        13.425354596189152,
                        59.378423405235395
                    ],
                    [
                        13.425406415196306,
                        59.3783421372986
                    ],
                    [
                        13.425561315216498,
                        59.37806094100546
                    ],
                    [
                        13.42566405847802,
                        59.37789814128621
                    ],
                    [
                        13.425733128902323,
                        59.37778586994855
                    ],
                    [
                        13.425770106028892,
                        59.37774405825152
                    ],
                    [
                        13.425842309747566,
                        59.377702552015904
                    ],
                    [
                        13.425913500049319,
                        59.377675590124284
                    ],
                    [
                        13.425997196203866,
                        59.37764460165508
                    ],
                    [
                        13.426037697084325,
                        59.37761990958495
                    ],
                    [
                        13.426072791320308,
                        59.37757623763986
                    ],
                    [
                        13.426193780946392,
                        59.37737974199925
                    ],
                    [
                        13.426450589312282,
                        59.376947073782105
                    ],
                    [
                        13.426833068699722,
                        59.376322139589604
                    ],
                    [
                        13.426858746031314,
                        59.37628696862376
                    ],
                    [
                        13.426945519794572,
                        59.3762691596221
                    ],
                    [
                        13.42702041878286,
                        59.37625198237302
                    ],
                    [
                        13.427077459108375,
                        59.37625143209911
                    ],
                    [
                        13.427396436096956,
                        59.37630946392534
                    ],
                    [
                        13.429349734851996,
                        59.37661504766902
                    ]
                ]);

                // Define two coordinate points
                const pointA = turfHelpers.point(kioskCoords);
                const pointB = turfHelpers.point(storeCoords);

                // Get the bearing between the two points
                let bearing = turfBearing(pointA, pointB);

                /*
                if(bearing > 0) bearing = this.mapbox.bearing - 20;
                if(bearing < 0) bearing = this.mapbox.bearing + 20;
                */
                this.kioskBearing = bearing;

                // Snap points to the closest location on the predefined line
                const snappedA = turfNearestPointOnLine(initialLine, pointA);
                const snappedB = turfNearestPointOnLine(initialLine, pointB);

                // get coordinates of point B
                const coordsB = snappedB.geometry.coordinates;

                // Extract the segment between snapped points
                const slicedLine = turfLineSlice(snappedA, snappedB, initialLine);

                // Check if adding or updating
                if (mapInstance.getLayer('routeLineLayer')) {
                    mapInstance.getSource('routeLine').setData(slicedLine);
                    //mapInstance.getSource('routeEndMarker').setData(snappedB);
                    mapInstance.setPaintProperty('routeLineLayer', 'line-opacity', 1);
                    mapInstance.setPaintProperty('routeLineLayerBelow', 'line-opacity', 1);
                    //mapInstance.setPaintProperty('routeEndMarkerLayer', 'line-opacity', 1);
                    //this.markerRoute.setLngLat(coordsB);
                } else {

                    // Add red sliced line
                    mapInstance.addSource('routeLine', {
                        type: 'geojson',
                        data: slicedLine
                    });
                    mapInstance.addLayer({
                        id: 'routeLineLayerBelow',
                        type: 'line',
                        source: 'routeLine',
                        layout: { 'line-cap': 'butt' },
                        paint: {
                            'line-color': '#9dc7c5',
                            'line-width': 14,
                            //'line-dasharray': [2, 2] // Dashed pattern (4px dash, 2px gap)
                        },
                        slot: 'middle'
                    });

                    mapInstance.addLayer({
                        id: 'routeLineLayer',
                        type: 'line',
                        source: 'routeLine',
                        layout: { 'line-cap': 'butt' },
                        paint: {
                            'line-color': '#d8efee',
                            'line-width': 10,
                            //'line-dasharray': [2, 2] // Dashed pattern (4px dash, 2px gap)
                        },
                        slot: 'middle'
                    });

                    /*
                    // Add marker
                    let marker = document.createElement('div');
                    marker.className = 'route-marker';
                    marker.innerHTML += '<div class="inner"></div>';
                    this.markerRoute = new mapboxgl.Marker(marker).setLngLat(coordsB).addTo(mapInstance);
                    */

                    /*
                    console.log(pointB);

                    // Add a layer that acts as a marker to the end point
                    mapInstance.addSource('routeEndMarker', {
                        type: 'geojson',
                        data: snappedB
                    });
                    mapInstance.addLayer({
                        id: 'routeEndMarkerLayer',
                        type: 'circle',
                        source: 'routeEndMarker',
                        paint: {
                            'circle-radius': 10,
                            'circle-color': '#d8efee',
                            'circle-stroke-color': '#9dc7c5',
                            'circle-stroke-width': 3
                        },
                        slot: 'middle'
                    });

                     */

                }


            },
            toggleDevSettings() {
                this.showDevSettings = !this.showDevSettings
            },
            getStoreFromPostId(id) {
                for (let i = 0; i < this.settings.storeData.length; i++) {
                    if (this.settings.storeData[i].postId === id) {
                        return this.settings.storeData[i];
                    }
                }
            },
            getServiceFromSlug(slug) {
                for (const service of this.settings.serviceData) {
                    if (service.slug === slug) {
                        return service;
                    }
                }
            },
            sidebarState() {
                let app = this;

                if (this.sidebar.stateWorking) return;
                this.sidebar.stateWorking = true;
                setTimeout(() => {
                    app.sidebar.stateWorking = false;
                }, 500);

                if (this.sidebar.state === 'open') {
                    this.setScene('list', true);
                    this.sidebar.state = 'hidden';
                    this.closeStore();
                } else if (this.sidebar.state === 'hidden') {
                    this.sidebar.state = 'open';
                    //setTimeout(() => app.$refs.searchInput.focus(), 500); // Wait for sidebar slide up animation ready
                } else if (this.sidebar.state === 'semiOpen') {
                    this.sidebar.state = 'hidden';
                }

                // Trigger resize event for map resize etc
                this.$nextTick(() => app.triggerResize());

                return false;
            },
            triggerResize() {
                window.dispatchEvent(new Event('resize'));
                //this.log('Resize event triggered');
            },
            toggleSidebar() {
                if (['desktopOpen', 'hidden', 'semiOpen', 'open'].includes(this.sidebar.state)) {
                    this.sidebar.state = 'desktopClosed';
                } else if (this.sidebar.state === 'desktopClosed') {
                    this.sidebar.state = 'desktopOpen';
                }
            },
            resetSidebar() {
                this.activeStore = null;

                if (this.mobile) {
                    this.sidebar.state = 'hidden';
                } else {
                    this.sidebar.state = 'desktopOpen';
                }
            },
            toggleFullscreen() {
                let app = this;
                let element = document.querySelector("#map-" + map.dataset.unique);
                //let element = document.documentElement;

                if (!this.fullscreen) {
                    if (element.requestFullscreen) {
                        element.requestFullscreen()
                            .then(function () {
                                app.fullscreen = true;
                            })
                            .catch(function (error) {
                            });
                    } else if (element.webkitRequestFullscreen) { /* Safari */
                        element.webkitRequestFullscreen()
                            .then(function () {
                                app.fullscreen = true;
                            })
                            .catch(function (error) {
                            });
                    } else if (element.msRequestFullscreen) { /* IE11 */
                        element.msRequestFullscreen()
                            .then(function () {
                                app.fullscreen = true;
                            })
                            .catch(function (error) {
                            });
                    }

                } else {

                    if (document.exitFullscreen) {
                        document.exitFullscreen()
                            .then(function () {
                                app.fullscreen = false;
                            })
                    } else if (document.webkitExitFullscreen) { /* Safari */
                        document.webkitExitFullscreen()
                            .then(function () {
                                app.fullscreen = false;
                            })
                    } else if (document.msExitFullscreen) { /* IE11 */
                        document.msExitFullscreen()
                            .then(function () {
                                app.fullscreen = false;
                            })
                    }
                }

                // Remove any prior fullscreen listener

                // Add Fullscreen listener
                document.addEventListener("fullscreenchange", () => {
                    if (document.fullscreenElement === null) {
                        app.fullscreen = false;
                    } else {
                        //console.log("Entered fullscreen");
                    }
                });

            },
            startThreebox() {
                let app = this;

                mapInstance.setMaxZoom(20);

                const origin = [app.mapbox.lng, app.mapbox.lat];

                const tb1 = (window.tb = new Threebox(mapInstance, mapInstance.getCanvas().getContext("webgl"), {
                    defaultLights: true,
                    enableSelectingObjects: false //change this to false to disable 3D objects selection
                    // change this to false to disable default tooltips on fill-extrusion and 3D models
                }));

                const tb2 = (window.tb = new Threebox(mapInstance, mapInstance.getCanvas().getContext("webgl"), {
                    defaultLights: true,
                    enableSelectingObjects: false //change this to false to disable 3D objects selection
                    // change this to false to disable default tooltips on fill-extrusion and 3D models
                }));


                //// initialize geometry and material of our cube object
                //const geometry = new THREE.BoxGeometry(30, 60, 120);

                // create two three.js lights to illuminate the model
                const directionalLight = new THREE.DirectionalLight(0xffffff);
                directionalLight.position.set(0, -70, 100).normalize();
                tb1.scene.add(directionalLight);


                const directionalLight2 = new THREE.DirectionalLight(0xffffff);
                directionalLight2.position.set(0, 70, 100).normalize();
                tb1.scene.add(directionalLight2);


                // https://sketchfab.com/nenjo

                const options1 = {
                    id: "circuit",
                    type: "glb",
                    obj:
                        "https://d39637iv3eybjn.cloudfront.net/low_poly_tree_-_fall.glb",
                    scale: 20,
                    units: "meters",
                    anchor: "center",
                    rotation: {x: 90, y: 62, z: 0}
                };

                tb1.loadObj(options1, (model) => {
                    const obj1 = model.setCoords(origin);
                    tb1.add(obj1);
                });

                mapInstance.addLayer({
                    id: "custom_layer_1",
                    type: "custom",
                    renderingMode: '3d',
                    render: function (gl, matrix) {
                        tb1.update();
                    }
                });


                const options2 = {
                    id: "circuit",
                    type: "glb",
                    obj:
                        "https://d39637iv3eybjn.cloudfront.net/panda.glb",
                    scale: 3,
                    units: "meters",
                    anchor: "center",
                    rotation: {x: 90, y: 62, z: 0}
                };

                tb2.loadObj(options2, (model) => {
                    const obj2 = model.setCoords([16.994194160578644, 60.63369618184743]);
                    tb2.add(obj2);
                });

                mapInstance.addLayer({
                    id: "custom_layer_2",
                    type: "custom",
                    renderingMode: '3d',
                    render: function (gl, matrix) {
                        tb2.update();
                    }
                });


                setTimeout(function () {

                    let tempBounds = [origin];

                    // Reset and add new bounds (https://docs.mapbox.com/mapbox-gl-js/example/zoomto-linestring/)
                    app.mapbox.bounds = tempBounds.reduce(function (bounds, coord) {
                        return bounds.extend(coord);
                    }, new mapboxgl.LngLatBounds(tempBounds[0], tempBounds[0]));


                    // Make sure not to zoom to much
                    mapInstance.fitBounds(app.mapbox.bounds, {
                        maxZoom: app.mapMaxZoom,
                        pitch: 50,
                        bearing: app.mapbox.bearing,
                        //speed: 0.75,
                        duration: 2000,
                        essential: true,
                        padding: {
                            top: app.mapPadding,
                            bottom: app.mapPadding,
                            left: app.leftPadding,
                            right: app.mapPadding
                        }
                    });

                    setTimeout(() => app.rotateCamera(0), 2500);

                }, 1000);
            },
            rotateCamera(timestamp) {
                // clamp the rotation between 0 -360 degrees
                // Divide timestamp by 100 to slow rotation to ~10 degrees / sec
                mapInstance.rotateTo((timestamp / 100) % 360, {duration: 0});
                // Request the next frame of the animation.
                requestAnimationFrame(this.rotateCamera);
            },
            getDistance(name1, latitude1_degrees, longitude1_degrees, name2, latitude2_degrees, longitude2_degrees) {
                const gc = {};

                gc.name1 = name1;
                gc.name2 = name2;
                gc.latitude1_degrees = latitude1_degrees;
                gc.longitude1_degrees = longitude1_degrees;
                gc.latitude2_degrees = latitude2_degrees;
                gc.longitude2_degrees = longitude2_degrees;

                gc.latitude1_radians = 0;
                gc.longitude1_radians = 0;
                gc.latitude2_radians = 0;
                gc.longitude2_radians = 0;
                gc.central_angle_radians = 0;
                gc.central_angle_degrees = 0;
                gc.distance_kilometres = 0;
                gc.distance_miles = 0;
                gc.valid = true;

                this.validateDegrees(gc);

                if (gc.valid) {
                    this.calculateRadians(gc);
                    this.calculateCentralAngle(gc);
                    this.calculateDistance(gc);
                }

                return gc;
            },
            validateDegrees(gc) {
                gc.valid = true;

                if (gc.latitude1_degrees < -90.0 || gc.latitude1_degrees > 90.0) {
                    gc.valid = false;
                }

                if (gc.longitude1_degrees < -180.0 || gc.longitude1_degrees > 180.0) {
                    gc.valid = false;
                }

                if (gc.latitude2_degrees < -90.0 || gc.latitude2_degrees > 90.0) {
                    gc.valid = false;
                }

                if (gc.longitude2_degrees < -180.0 || gc.longitude2_degrees > 180.0) {
                    gc.valid = false;
                }
            },
            calculateRadians(gc) {
                gc.latitude1_radians = gc.latitude1_degrees / DEGREES_IN_RADIAN;
                gc.longitude1_radians = gc.longitude1_degrees / DEGREES_IN_RADIAN;

                gc.latitude2_radians = gc.latitude2_degrees / DEGREES_IN_RADIAN;
                gc.longitude2_radians = gc.longitude2_degrees / DEGREES_IN_RADIAN;
            },
            calculateCentralAngle(gc) {
                var longitudes_abs_diff;

                if (gc.longitude1_radians > gc.longitude2_radians) {
                    longitudes_abs_diff = gc.longitude1_radians - gc.longitude2_radians;
                } else {
                    longitudes_abs_diff = gc.longitude2_radians - gc.longitude1_radians;
                }

                gc.central_angle_radians = Math.acos(Math.sin(gc.latitude1_radians)
                    * Math.sin(gc.latitude2_radians)
                    + Math.cos(gc.latitude1_radians)
                    * Math.cos(gc.latitude2_radians)
                    * Math.cos(longitudes_abs_diff));

                gc.central_angle_degrees = gc.central_angle_radians * DEGREES_IN_RADIAN;
            },
            calculateDistance(gc) {
                gc.distance_kilometres = MEAN_EARTH_RADIUS_KM * gc.central_angle_radians;
                gc.distance_miles = gc.distance_kilometres / KILOMETRES_IN_MILE;
            },
            listenForTriggers(triggerClass) {
                if (triggerClass) {
                    let triggers = document.querySelectorAll('.' + triggerClass);
                    if (triggers) {
                        triggers.forEach((trigger) => {

                            trigger.addEventListener("click", (e) => {
                                window['mapApp_' + map.dataset.unique].openLightbox();
                                e.preventDefault();
                                return false;
                            });
                        });
                    }
                }
            }

        },
        mounted: function () {


            this.log(this.settings);

            let app = this;

            // Check if we are in dev mode based on .test domain
            if(window.location.hostname.includes('.test')){
                this.isDev = true;
            }

            if (this.isDemo) {
                this.use3d = true;
                this.mapbox.styles[0] = 'mapbox://styles/mapbox/standard';
            }



            if (!this.widgetSettings.lightbox) {
                this.initMap();
            } else {
                if (window.innerWidth < breakpoint) {
                    this.sidebar.state = 'hidden';
                }

                // Check for open trigger elements
                let triggerClass = this.widgetSettings.lightbox_trigger;
                app.listenForTriggers(triggerClass);

                // Add event for popups as well since trigger can be in popups and not in DOM on page load
                jQuery( document ).on( 'elementor/popup/show', ( event, id, instance ) => {
                    app.listenForTriggers(triggerClass);
                });
            }

            app.checkParams();
        },
        created() {

        },
        components: {},
    });

    // Mount app to DOM
    if (document.getElementById('map-' + map.dataset.unique)) {
        window['mapApp_' + map.dataset.unique] = app.mount('#map-' + map.dataset.unique);
    }


}); // End foreach map


// ---------------------------------------//
// Great Circle Distance calculations
// To calculate if current position is close enough to a question


const DEGREES_IN_RADIAN = 57.29577951
const MEAN_EARTH_RADIUS_KM = 6371
const KILOMETRES_IN_MILE = 1.60934


// END DISTANCE CALCULATOR
//---------------------------------------//



// KALMAN FILTER - HANDLE BAD GPS VALUES
//---------------------------------------//
class KalmanFilter {
    constructor(R = 1, Q = 1) {
        this.R = R; // Mätningsosäkerhet
        this.Q = Q; // Processosäkerhet
        this.A = 1; // Tidssteg (ingen förändring)
        this.C = 1; // Direkt mätning
        this.cov = NaN; // Initial osäkerhet
        this.x = NaN; // Initial uppskattning
    }

    filter(z) {
        if (isNaN(this.x)) {
            this.x = z;
            this.cov = 1;
        } else {
            let predX = this.A * this.x;
            let predCov = this.A * this.cov * this.A + this.Q;
            let K = predCov * this.C / (this.C * predCov * this.C + this.R);
            this.x = predX + K * (z - this.C * predX);
            this.cov = predCov - K * this.C * predCov;
        }
        return this.x;
    }
}

// Kalman-filter för latitud och longitud
const kalmanLat = new KalmanFilter(2, 0.1);
const kalmanLng = new KalmanFilter(2, 0.1);